// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options as ClientOptions,
  type TDataShape,
  type Client,
  formDataBodySerializer,
  urlSearchParamsBodySerializer,
} from './client'
import type {
  GetScheduledDriveByVehicleData,
  GetScheduledDriveByVehicleResponses,
  GetScheduledDriveByVehicleErrors,
  CheckVehicleMaintenanceModeData,
  CheckVehicleMaintenanceModeResponses,
  CheckVehicleMaintenanceModeErrors,
  SubmitStatusData,
  SubmitStatusResponses,
  SubmitStatusErrors,
  SubmitVehicleVersionsData,
  SubmitVehicleVersionsResponses,
  SubmitVehicleVersionsErrors,
  SubmitParkingRecordData,
  SubmitParkingRecordResponses,
  SubmitParkingRecordErrors,
  GetParkingRecordResponseData,
  GetParkingRecordResponseResponses,
  GetParkingRecordResponseErrors,
  SubmitRouteRecordData,
  SubmitRouteRecordResponses,
  SubmitRouteRecordErrors,
  SubmitEvidencePackageData,
  SubmitEvidencePackageResponses,
  SubmitEvidencePackageErrors,
  ShouldSubmitEvidencePackageData,
  ShouldSubmitEvidencePackageResponses,
  ShouldSubmitEvidencePackageErrors,
  SubmitSkippedRouteSegmentRecordData,
  SubmitSkippedRouteSegmentRecordResponses,
  SubmitSkippedRouteSegmentRecordErrors,
  SubmitSignPostRecordData,
  SubmitSignPostRecordResponses,
  SubmitSignPostRecordErrors,
  SubmitUnexpectedEventData,
  SubmitUnexpectedEventResponses,
  SubmitUnexpectedEventErrors,
  SubmitUnexpectedEventPackageData,
  SubmitUnexpectedEventPackageResponses,
  SubmitUnexpectedEventPackageErrors,
  ShouldSubmitUnexpectedEventPackageData,
  ShouldSubmitUnexpectedEventPackageResponses,
  ShouldSubmitUnexpectedEventPackageErrors,
  SubmitVehiclePositionData,
  SubmitVehiclePositionResponses,
  SubmitVehiclePositionErrors,
  GetDriversAndScheduledShiftsData,
  GetDriversAndScheduledShiftsResponses,
  GetDriversAndScheduledShiftsErrors,
  GetActiveWorkPeriodData,
  GetActiveWorkPeriodResponses,
  GetActiveWorkPeriodErrors,
  DriverSignInData,
  DriverSignInResponses,
  DriverSignInErrors,
  DriverSignOutData,
  DriverSignOutResponses,
  DriverSignOutErrors,
  ReportDriveStartedData,
  ReportDriveStartedResponses,
  ReportDriveStartedErrors,
  ReportDriveFinishedData,
  ReportDriveFinishedResponses,
  ReportDriveFinishedErrors,
  GetFinishedDriveStatisticsData,
  GetFinishedDriveStatisticsResponses,
  GetFinishedDriveStatisticsErrors,
  ScheduleFreerideData,
  ScheduleFreerideResponses,
  ScheduleFreerideErrors,
  PostComputeRoutesData,
  PostComputeRoutesResponses,
  PostComputeRoutesErrors,
  GetEmptyTechnicalSegmentsData,
  GetEmptyTechnicalSegmentsResponses,
  GetEmptyTechnicalSegmentsErrors,
  SubmitEmptyTechnicalSegmentEvidenceData,
  SubmitEmptyTechnicalSegmentEvidenceResponses,
  SubmitEmptyTechnicalSegmentEvidenceErrors,
  DeleteEmptyTechnicalSegmentsData,
  DeleteEmptyTechnicalSegmentsResponses,
  DeleteEmptyTechnicalSegmentsErrors,
  GetAllPlanningAreasData,
  GetAllPlanningAreasResponses,
  GetAllPlanningAreasErrors,
  DeletePlanningAreaData,
  DeletePlanningAreaResponses,
  DeletePlanningAreaErrors,
  GetPlanningAreaData,
  GetPlanningAreaResponses,
  GetPlanningAreaErrors,
  UpdatePlanningAreaData,
  UpdatePlanningAreaResponses,
  UpdatePlanningAreaErrors,
  CreateDistrictData,
  CreateDistrictResponses,
  CreateDistrictErrors,
  GetPlanningDataData,
  GetPlanningDataResponses,
  GetPlanningDataErrors,
  GetDistrictMapData,
  GetDistrictMapResponses,
  GetDistrictMapErrors,
  GetAllActiveRoutesData,
  GetAllActiveRoutesResponses,
  GetAllActiveRoutesErrors,
  GetRouteProblemsSummaryData,
  GetRouteProblemsSummaryResponses,
  GetRouteProblemsSummaryErrors,
  GetRoutesInAreaData,
  GetRoutesInAreaResponses,
  GetRoutesInAreaErrors,
  GetRouteTsCoverageAllData,
  GetRouteTsCoverageAllResponses,
  GetRouteTsCoverageAllErrors,
  GetRouteTsCoverageData,
  GetRouteTsCoverageResponses,
  GetRouteTsCoverageErrors,
  CheckRouteWithGoogleMapsData,
  CheckRouteWithGoogleMapsResponses,
  CheckRouteWithGoogleMapsErrors,
  ValidateStreetSegmentGeometryData,
  ValidateStreetSegmentGeometryResponses,
  ValidateStreetSegmentGeometryErrors,
  DeleteRouteData,
  DeleteRouteResponses,
  DeleteRouteErrors,
  GetRouteData,
  GetRouteResponses,
  GetRouteErrors,
  CreateRouteData,
  CreateRouteResponses,
  CreateRouteErrors,
  DeleteRouteDrivesData,
  DeleteRouteDrivesResponses,
  DeleteRouteDrivesErrors,
  UpdateRouteFragmentsData,
  UpdateRouteFragmentsResponses,
  UpdateRouteFragmentsErrors,
  AutogenerateRouteFragmentsData,
  AutogenerateRouteFragmentsResponses,
  AutogenerateRouteFragmentsErrors,
  GetStreetSegmentsInPolygonData,
  GetStreetSegmentsInPolygonResponses,
  GetStreetSegmentsInPolygonErrors,
  GetDistrictPlanningDataData,
  GetDistrictPlanningDataResponses,
  GetDistrictPlanningDataErrors,
  GetAllPlanningDataData,
  GetAllPlanningDataResponses,
  GetAllPlanningDataErrors,
  PostPlanningDataInPolygonData,
  PostPlanningDataInPolygonResponses,
  PostPlanningDataInPolygonErrors,
  GetOverrideListData,
  GetOverrideListResponses,
  GetOverrideListErrors,
  GetSnapshotListData,
  GetSnapshotListResponses,
  GetSnapshotListErrors,
  GetSnapshotListWithOverridesData,
  GetSnapshotListWithOverridesResponses,
  GetSnapshotListWithOverridesErrors,
  CompareTwoSnapshotsData,
  CompareTwoSnapshotsResponses,
  CompareTwoSnapshotsErrors,
  GetStreetSegmentsData,
  GetStreetSegmentsResponses,
  GetStreetSegmentsErrors,
  GetTskSegmentsData,
  GetTskSegmentsResponses,
  GetTskSegmentsErrors,
  GetRequirementsData,
  GetRequirementsResponses,
  GetRequirementsErrors,
  GetRequirementsDocuData,
  GetRequirementsDocuResponses,
  GetRequirementsDocuErrors,
  GetControlDataSchemasData,
  GetControlDataSchemasResponses,
  GetControlDataSchemasErrors,
  CreateMapSnapshotData,
  CreateMapSnapshotResponses,
  CreateMapSnapshotErrors,
  GetCurrentSnapshotData,
  GetCurrentSnapshotResponses,
  GetCurrentSnapshotErrors,
  GetControlDataDataVersionData,
  GetControlDataDataVersionResponses,
  GetControlDataDataVersionErrors,
  SyncMapsData,
  SyncMapsResponses,
  SyncMapsErrors,
  DeleteSnapshotData,
  DeleteSnapshotResponses,
  DeleteSnapshotErrors,
  SyncOpenstreetmapsData,
  SyncOpenstreetmapsResponses,
  SyncOpenstreetmapsErrors,
  GetStreetSegmentData,
  GetStreetSegmentResponses,
  GetStreetSegmentErrors,
  GetTechnicalSegmentData,
  GetTechnicalSegmentResponses,
  GetTechnicalSegmentErrors,
  GetRegulatedZoneData,
  GetRegulatedZoneResponses,
  GetRegulatedZoneErrors,
  GetSignPostData,
  GetSignPostResponses,
  GetSignPostErrors,
  GetPlanningAreaSplitsData,
  GetPlanningAreaSplitsResponses,
  GetPlanningAreaSplitsErrors,
  SavePlanningAreaSplitsData,
  SavePlanningAreaSplitsResponses,
  SavePlanningAreaSplitsErrors,
  GetSplitsDistrictPlanningDataData,
  GetSplitsDistrictPlanningDataResponses,
  GetSplitsDistrictPlanningDataErrors,
  ComputeDistrictSplitsData,
  ComputeDistrictSplitsResponses,
  ComputeDistrictSplitsErrors,
  GetDistrictsWithRequestedSegmentsData,
  GetDistrictsWithRequestedSegmentsResponses,
  GetDistrictsWithRequestedSegmentsErrors,
  GetPendingRecomputeData,
  GetPendingRecomputeResponses,
  GetPendingRecomputeErrors,
  GetAllSplitProblemsData,
  GetAllSplitProblemsResponses,
  GetAllSplitProblemsErrors,
  GetDsTariffRootMapData,
  GetDsTariffRootMapResponses,
  GetDsTariffRootMapErrors,
  GetDsDriveTimesData,
  GetDsDriveTimesResponses,
  GetDsDriveTimesErrors,
  GetDsDriveOverviewData,
  GetDsDriveOverviewResponses,
  GetDsDriveOverviewErrors,
  GetDsBigClosuresData,
  GetDsBigClosuresResponses,
  GetDsBigClosuresErrors,
  GetDsRouteMapData,
  GetDsRouteMapResponses,
  GetDsRouteMapErrors,
  RoutesMapDataData,
  RoutesMapDataResponses,
  RoutesMapDataErrors,
  RoutesMapViewportData,
  RoutesMapViewportResponses,
  RoutesMapViewportErrors,
  RoutesMapRouteDetailData,
  RoutesMapRouteDetailResponses,
  RoutesMapRouteDetailErrors,
  RoutesMapSearchData,
  RoutesMapSearchResponses,
  RoutesMapSearchErrors,
  UpdateStreetSegmentData,
  UpdateStreetSegmentResponses,
  UpdateStreetSegmentErrors,
  DeleteStreetSegmentOverrideData,
  DeleteStreetSegmentOverrideResponses,
  DeleteStreetSegmentOverrideErrors,
  UpsertStreetSegmentOverrideData,
  UpsertStreetSegmentOverrideResponses,
  UpsertStreetSegmentOverrideErrors,
  UpdateTechnicalSegmentData,
  UpdateTechnicalSegmentResponses,
  UpdateTechnicalSegmentErrors,
  UpdateRegulatedZoneData,
  UpdateRegulatedZoneResponses,
  UpdateRegulatedZoneErrors,
  UpdateSignPostData,
  UpdateSignPostResponses,
  UpdateSignPostErrors,
  UpdateControlDataStructureData,
  UpdateControlDataStructureResponses,
  UpdateControlDataStructureErrors,
  UpdateToOverrideBasedControlDataStructureData,
  UpdateToOverrideBasedControlDataStructureResponses,
  UpdateToOverrideBasedControlDataStructureErrors,
  RollbackToLegacyControlDataStructureData,
  RollbackToLegacyControlDataStructureResponses,
  RollbackToLegacyControlDataStructureErrors,
  CopyAndUpdateControlDataStructureData,
  CopyAndUpdateControlDataStructureResponses,
  CopyAndUpdateControlDataStructureErrors,
  ImportTechnicalSegmentsRegulatedZonesAndSignPostsData,
  ImportTechnicalSegmentsRegulatedZonesAndSignPostsResponses,
  ImportTechnicalSegmentsRegulatedZonesAndSignPostsErrors,
  FreezeTechnicalSegmentStreetPairingData,
  FreezeTechnicalSegmentStreetPairingResponses,
  FreezeTechnicalSegmentStreetPairingErrors,
  PairTechnicalSegments2StreetSegmentsData,
  PairTechnicalSegments2StreetSegmentsResponses,
  PairTechnicalSegments2StreetSegmentsErrors,
  ComputeSsdrData,
  ComputeSsdrResponses,
  ComputeSsdrErrors,
  CompareRowsData,
  CompareRowsResponses,
  CompareRowsErrors,
  ApplyCompareChangeData,
  ApplyCompareChangeResponses,
  ApplyCompareChangeErrors,
  PullControlDataData,
  PullControlDataResponses,
  PullControlDataErrors,
  DeleteControlDataSchemaData,
  DeleteControlDataSchemaResponses,
  DeleteControlDataSchemaErrors,
  GetAllVehiclesData,
  GetAllVehiclesResponses,
  GetAllVehiclesErrors,
  GetVehicleData,
  GetVehicleResponses,
  GetVehicleErrors,
  UpdateVehicleData,
  UpdateVehicleResponses,
  UpdateVehicleErrors,
  GetVehicleLastStatusData,
  GetVehicleLastStatusResponses,
  GetVehicleLastStatusErrors,
  GetVehicleMetricsData,
  GetVehicleMetricsResponses,
  GetVehicleMetricsErrors,
  GetVehicleNavigationDataData,
  GetVehicleNavigationDataResponses,
  GetVehicleNavigationDataErrors,
  SetVehicleMaintenanceModeData,
  SetVehicleMaintenanceModeResponses,
  SetVehicleMaintenanceModeErrors,
  GetAllDriversData,
  GetAllDriversResponses,
  GetAllDriversErrors,
  CreateDriverData,
  CreateDriverResponses,
  CreateDriverErrors,
  GetExternalDriversData,
  GetExternalDriversResponses,
  GetExternalDriversErrors,
  ImportExternalDriverData,
  ImportExternalDriverResponses,
  ImportExternalDriverErrors,
  AssociateExternalDriverData,
  AssociateExternalDriverResponses,
  AssociateExternalDriverErrors,
  GetDriverData,
  GetDriverResponses,
  GetDriverErrors,
  UpdateDriverData,
  UpdateDriverResponses,
  UpdateDriverErrors,
  GetInactiveDriversData,
  GetInactiveDriversResponses,
  GetInactiveDriversErrors,
  GetDailyScheduleData,
  GetDailyScheduleResponses,
  GetDailyScheduleErrors,
  GetScheduleForIntervalData,
  GetScheduleForIntervalResponses,
  GetScheduleForIntervalErrors,
  GetShiftOverviewData,
  GetShiftOverviewResponses,
  GetShiftOverviewErrors,
  DeleteShiftData,
  DeleteShiftResponses,
  DeleteShiftErrors,
  GetScheduledDrivesData,
  GetScheduledDrivesResponses,
  GetScheduledDrivesErrors,
  ScheduleDriveData,
  ScheduleDriveResponses,
  ScheduleDriveErrors,
  GetScheduledDriveData,
  GetScheduledDriveResponses,
  GetScheduledDriveErrors,
  UpdateScheduledDriveData,
  UpdateScheduledDriveResponses,
  UpdateScheduledDriveErrors,
  ReorderScheduledDrivesData,
  ReorderScheduledDrivesResponses,
  ReorderScheduledDrivesErrors,
  RescheduleDriveData,
  RescheduleDriveResponses,
  RescheduleDriveErrors,
  MoveScheduleData,
  MoveScheduleResponses,
  MoveScheduleErrors,
  GetCurrentDrivesData,
  GetCurrentDrivesResponses,
  GetCurrentDrivesErrors,
  CancelScheduledDriveData,
  CancelScheduledDriveResponses,
  CancelScheduledDriveErrors,
  ApproveScheduledDriveData,
  ApproveScheduledDriveResponses,
  ApproveScheduledDriveErrors,
  DisapproveScheduledDriveData,
  DisapproveScheduledDriveResponses,
  DisapproveScheduledDriveErrors,
  GetDriveIntervalsData,
  GetDriveIntervalsResponses,
  GetDriveIntervalsErrors,
  GetRequirementSubintervalsData,
  GetRequirementSubintervalsResponses,
  GetRequirementSubintervalsErrors,
  GetRequirementFulfillmentPerSegmentData,
  GetRequirementFulfillmentPerSegmentResponses,
  GetRequirementFulfillmentPerSegmentErrors,
  GetRequirementFulfillmentData,
  GetRequirementFulfillmentResponses,
  GetRequirementFulfillmentErrors,
  SyncShiftsOnDemandData,
  SyncShiftsOnDemandResponses,
  SyncShiftsOnDemandErrors,
  GetPingVehicleData,
  GetPingVehicleResponses,
  GetPingVehicleErrors,
  PopulateIntervalData,
  PopulateIntervalResponses,
  PopulateIntervalErrors,
  ManuallyPopulateIntervalData,
  ManuallyPopulateIntervalResponses,
  ManuallyPopulateIntervalErrors,
  ScheduleDistrictsData,
  ScheduleDistrictsResponses,
  ScheduleDistrictsErrors,
  CopyVehicleScheduleData,
  CopyVehicleScheduleResponses,
  CopyVehicleScheduleErrors,
  ScheduleDocumentationDayData,
  ScheduleDocumentationDayResponses,
  ScheduleDocumentationDayErrors,
  ScheduleDocumentationMonthData,
  ScheduleDocumentationMonthResponses,
  ScheduleDocumentationMonthErrors,
  ScheduleItstDayData,
  ScheduleItstDayResponses,
  ScheduleItstDayErrors,
  ScheduleItstMonthData,
  ScheduleItstMonthResponses,
  ScheduleItstMonthErrors,
  ApplyDsPlanEndpointData,
  ApplyDsPlanEndpointResponses,
  ApplyDsPlanEndpointErrors,
  GetDrivesByDateData,
  GetDrivesByDateResponses,
  GetDrivesByDateErrors,
  GetDailyDriveOverviewData,
  GetDailyDriveOverviewResponses,
  GetDailyDriveOverviewErrors,
  GetScheduledDriveStatisticsData,
  GetScheduledDriveStatisticsResponses,
  GetScheduledDriveStatisticsErrors,
  GetPackageSubmissionDetailData,
  GetPackageSubmissionDetailResponses,
  GetPackageSubmissionDetailErrors,
  GetDetailedDriveStatisticsData,
  GetDetailedDriveStatisticsResponses,
  GetDetailedDriveStatisticsErrors,
  GetDriverStatisticsData,
  GetDriverStatisticsResponses,
  GetDriverStatisticsErrors,
  GetElapsedDriverTimeData,
  GetElapsedDriverTimeResponses,
  GetElapsedDriverTimeErrors,
  GetAllRouteStatisticsData,
  GetAllRouteStatisticsResponses,
  GetAllRouteStatisticsErrors,
  GetDistrictOverheadStatisticsData,
  GetDistrictOverheadStatisticsResponses,
  GetDistrictOverheadStatisticsErrors,
  GetRouteStatisticsData,
  GetRouteStatisticsResponses,
  GetRouteStatisticsErrors,
  GetOperationMetricsData,
  GetOperationMetricsResponses,
  GetOperationMetricsErrors,
  GetOperationReportDriversData,
  GetOperationReportDriversResponses,
  GetOperationReportDriversErrors,
  GetOperationReportRoutesData,
  GetOperationReportRoutesResponses,
  GetOperationReportRoutesErrors,
  GetDetectionComparisonFirstDrivesData,
  GetDetectionComparisonFirstDrivesResponses,
  GetDetectionComparisonFirstDrivesErrors,
  GetDetectionComparisonSecondDrivesData,
  GetDetectionComparisonSecondDrivesResponses,
  GetDetectionComparisonSecondDrivesErrors,
  GetDetectionComparisonData,
  GetDetectionComparisonResponses,
  GetDetectionComparisonErrors,
  GetDriveEventsData,
  GetDriveEventsResponses,
  GetDriveEventsErrors,
  GetDrivenStreetSegmentsData,
  GetDrivenStreetSegmentsResponses,
  GetDrivenStreetSegmentsErrors,
  GetParkingSignDetectionCountData,
  GetParkingSignDetectionCountResponses,
  GetParkingSignDetectionCountErrors,
  GetTechnicalSegmentDetectionCountData,
  GetTechnicalSegmentDetectionCountResponses,
  GetTechnicalSegmentDetectionCountErrors,
  GetDocumentationOverviewData,
  GetDocumentationOverviewResponses,
  GetDocumentationOverviewErrors,
  GetSignPostConfidencesData,
  GetSignPostConfidencesResponses,
  GetSignPostConfidencesErrors,
  GetTasksData,
  GetTasksResponses,
  GetTasksErrors,
  GetTasksForIntervalData,
  GetTasksForIntervalResponses,
  GetTasksForIntervalErrors,
  GetAllBillingPeriodsData,
  GetAllBillingPeriodsResponses,
  GetAllBillingPeriodsErrors,
  CreateBillingPeriodData,
  CreateBillingPeriodResponses,
  CreateBillingPeriodErrors,
  GetTaskBillingPeriodsData,
  GetTaskBillingPeriodsResponses,
  GetTaskBillingPeriodsErrors,
  DeleteBillingPeriodData,
  DeleteBillingPeriodResponses,
  DeleteBillingPeriodErrors,
  GetBillingPeriodDetailData,
  GetBillingPeriodDetailResponses,
  GetBillingPeriodDetailErrors,
  UpdateBillingPeriodData,
  UpdateBillingPeriodResponses,
  UpdateBillingPeriodErrors,
  UpdateBillingPeriodPricesData,
  UpdateBillingPeriodPricesResponses,
  UpdateBillingPeriodPricesErrors,
  ImportOrderData,
  ImportOrderResponses,
  ImportOrderErrors,
  GetDriveBillingDataData,
  GetDriveBillingDataResponses,
  GetDriveBillingDataErrors,
  GetBillingAuditDataData,
  GetBillingAuditDataResponses,
  GetBillingAuditDataErrors,
  GetBilledAmountHistoryData,
  GetBilledAmountHistoryResponses,
  GetBilledAmountHistoryErrors,
  GetInvoiceDetailData,
  GetInvoiceDetailResponses,
  GetInvoiceDetailErrors,
  GetInvoiceDetailCsvData,
  GetInvoiceDetailCsvResponses,
  GetInvoiceDetailCsvErrors,
  GetInvoiceCsvData,
  GetInvoiceCsvResponses,
  GetInvoiceCsvErrors,
  GetInvoiceCsvTotalsData,
  GetInvoiceCsvTotalsResponses,
  GetInvoiceCsvTotalsErrors,
  GetStreetSegmentAuditDataData,
  GetStreetSegmentAuditDataResponses,
  GetStreetSegmentAuditDataErrors,
  GetTechnicalSegmentAuditDataData,
  GetTechnicalSegmentAuditDataResponses,
  GetTechnicalSegmentAuditDataErrors,
  GetInvoiceAttachmentZipData,
  GetInvoiceAttachmentZipResponses,
  GetInvoiceAttachmentZipErrors,
  GetMetricsData,
  GetMetricsResponses,
  GetMetricsErrors,
  CheckHealthData,
  CheckHealthResponses,
  CheckHealthErrors,
  AuthenticateUserData,
  AuthenticateUserResponses,
  AuthenticateUserErrors,
  RefreshTokenData,
  RefreshTokenResponses,
  RefreshTokenErrors,
  IntrospectUserData,
  IntrospectUserResponses,
  IntrospectUserErrors,
  ChangeOwnPasswordData,
  ChangeOwnPasswordResponses,
  ChangeOwnPasswordErrors,
  LogEvidenceSubmissionData,
  LogEvidenceSubmissionResponses,
  LogEvidenceSubmissionErrors,
  GetEventPayloadData,
  GetEventPayloadResponses,
  GetEventPayloadErrors,
  GetPackageScoresData,
  GetPackageScoresResponses,
  GetPackageScoresErrors,
  GetPassRequestData,
  GetPassRequestResponses,
  GetPassRequestErrors,
  ResubmitEventsData,
  ResubmitEventsResponses,
  ResubmitEventsErrors,
  DeprecatedGetMapSchemaSnapshotVersionData,
  DeprecatedGetMapSchemaSnapshotVersionResponses,
  DeprecatedGetMapSchemaSnapshotVersionErrors,
  GetControlDataVersionData,
  GetControlDataVersionResponses,
  GetControlDataVersionErrors,
  GetControlDataContentsData,
  GetControlDataContentsResponses,
  GetControlDataContentsErrors,
  DeprecatedGetMapSchemaContentsData,
  DeprecatedGetMapSchemaContentsResponses,
  DeprecatedGetMapSchemaContentsErrors,
  GetAllUnexpectedEventsData,
  GetAllUnexpectedEventsResponses,
  GetAllUnexpectedEventsErrors,
  GetPendingUnexpectedEventsData,
  GetPendingUnexpectedEventsResponses,
  GetPendingUnexpectedEventsErrors,
  GetArchivedUnexpectedEventsData,
  GetArchivedUnexpectedEventsResponses,
  GetArchivedUnexpectedEventsErrors,
  GetUnexpectedEventCameraCapturesData,
  GetUnexpectedEventCameraCapturesResponses,
  GetUnexpectedEventCameraCapturesErrors,
  GetUnexpectedEventDetailsData,
  GetUnexpectedEventDetailsResponses,
  GetUnexpectedEventDetailsErrors,
  GetAnnexationsForDayData,
  GetAnnexationsForDayResponses,
  GetAnnexationsForDayErrors,
  ResolveUnexpectedEventData,
  ResolveUnexpectedEventResponses,
  ResolveUnexpectedEventErrors,
  UnresolveUnexpectedEventData,
  UnresolveUnexpectedEventResponses,
  UnresolveUnexpectedEventErrors,
  GetAffectedRoutesData,
  GetAffectedRoutesResponses,
  GetAffectedRoutesErrors,
  GetEnvInfoData,
  GetEnvInfoResponses,
  CleanCacheData,
  CleanCacheResponses,
  CleanCacheErrors,
  CleanBillingCacheData,
  CleanBillingCacheResponses,
  CleanBillingCacheErrors,
  GetHotlineCallsData,
  GetHotlineCallsResponses,
  GetHotlineCallsErrors,
  GetChunksData,
  GetChunksResponses,
  GetChunksErrors,
  GetChunkDetailData,
  GetChunkDetailResponses,
  GetChunkDetailErrors,
  PostChunkQualityData,
  PostChunkQualityResponses,
  PostChunkQualityErrors,
  GetImageData,
  GetImageResponses,
  GetImageErrors,
  GetReportCsvData,
  GetReportCsvResponses,
  GetReportCsvErrors,
  ListRolesData,
  ListRolesResponses,
  ListRolesErrors,
  CreateRoleData,
  CreateRoleResponses,
  CreateRoleErrors,
  DeleteRoleData,
  DeleteRoleResponses,
  DeleteRoleErrors,
  GetRoleData,
  GetRoleResponses,
  GetRoleErrors,
  UpdateRoleData,
  UpdateRoleResponses,
  UpdateRoleErrors,
  ListUsersData,
  ListUsersResponses,
  ListUsersErrors,
  CreateUserData,
  CreateUserResponses,
  CreateUserErrors,
  DeleteUserData,
  DeleteUserResponses,
  DeleteUserErrors,
  GetUserData,
  GetUserResponses,
  GetUserErrors,
  UpdateUserData,
  UpdateUserResponses,
  UpdateUserErrors,
  PushReportData,
  PushReportResponses,
  PushReportErrors,
} from './types.gen'
import { client as _heyApiClient } from './@tanstack/initializer'

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Get Scheduled Drive By Vehicle
 * Get a drive currently scheduled for the authenticated vehicle.
 */
export const getScheduledDriveByVehicle = <ThrowOnError extends boolean = false>(
  options?: Options<GetScheduledDriveByVehicleData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetScheduledDriveByVehicleResponses,
    GetScheduledDriveByVehicleErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/scheduled-drive',
    ...options,
  })
}

/**
 * Check Vehicle Maintenance Mode
 */
export const checkVehicleMaintenanceMode = <ThrowOnError extends boolean = false>(
  options?: Options<CheckVehicleMaintenanceModeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CheckVehicleMaintenanceModeResponses,
    CheckVehicleMaintenanceModeErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/maintenance-mode',
    ...options,
  })
}

/**
 * Submit Status
 * Submit status information for the patrol vehicle. The information is stored for a limited period of time.
 * This endpoint is expected to be called periodically, regardless of scheduled drives.
 */
export const submitStatus = <ThrowOnError extends boolean = false>(
  options: Options<SubmitStatusData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<SubmitStatusResponses, SubmitStatusErrors, ThrowOnError>({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Submit Vehicle Versions
 * Submit vehicle versions for the patrol vehicle.
 * This endpoint is expected to be called on vehicle startup/after update.
 */
export const submitVehicleVersions = <ThrowOnError extends boolean = false>(
  options: Options<SubmitVehicleVersionsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SubmitVehicleVersionsResponses,
    SubmitVehicleVersionsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/submit-versions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Submit Parking Record
 */
export const submitParkingRecord = <ThrowOnError extends boolean = false>(
  options: Options<SubmitParkingRecordData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<SubmitParkingRecordResponses, SubmitParkingRecordErrors, ThrowOnError>({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/drives/{drive_id}/parking-record',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Parking Record Response
 */
export const getParkingRecordResponse = <ThrowOnError extends boolean = false>(
  options: Options<GetParkingRecordResponseData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetParkingRecordResponseResponses,
    GetParkingRecordResponseErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/parking-record/{cis_event_id}/response',
    ...options,
  })
}

/**
 * Submit Route Record
 */
export const submitRouteRecord = <ThrowOnError extends boolean = false>(
  options: Options<SubmitRouteRecordData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<SubmitRouteRecordResponses, SubmitRouteRecordErrors, ThrowOnError>({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/drives/{drive_id}/route-record',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Submit Evidence Package
 */
export const submitEvidencePackage = <ThrowOnError extends boolean = false>(
  options: Options<SubmitEvidencePackageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SubmitEvidencePackageResponses,
    SubmitEvidencePackageErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/evidence-package',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  })
}

/**
 * Should Submit Evidence Package
 * Check whether an evidence package should be submitted.
 */
export const shouldSubmitEvidencePackage = <ThrowOnError extends boolean = false>(
  options?: Options<ShouldSubmitEvidencePackageData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ShouldSubmitEvidencePackageResponses,
    ShouldSubmitEvidencePackageErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/should-submit-evidence-package',
    ...options,
  })
}

/**
 * Submit Skipped Route Segment Record
 */
export const submitSkippedRouteSegmentRecord = <ThrowOnError extends boolean = false>(
  options: Options<SubmitSkippedRouteSegmentRecordData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SubmitSkippedRouteSegmentRecordResponses,
    SubmitSkippedRouteSegmentRecordErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/drives/{drive_id}/skipped-route-segment-record',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Submit Sign Post Record
 */
export const submitSignPostRecord = <ThrowOnError extends boolean = false>(
  options: Options<SubmitSignPostRecordData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SubmitSignPostRecordResponses,
    SubmitSignPostRecordErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/drives/{drive_id}/sign-post-record',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Submit Unexpected Event
 */
export const submitUnexpectedEvent = <ThrowOnError extends boolean = false>(
  options: Options<SubmitUnexpectedEventData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SubmitUnexpectedEventResponses,
    SubmitUnexpectedEventErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/drives/{drive_id}/unexpected-event',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Submit Unexpected Event Package
 */
export const submitUnexpectedEventPackage = <ThrowOnError extends boolean = false>(
  options: Options<SubmitUnexpectedEventPackageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SubmitUnexpectedEventPackageResponses,
    SubmitUnexpectedEventPackageErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/unexpected-event-package',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  })
}

/**
 * Should Submit Unexpected Event Package
 */
export const shouldSubmitUnexpectedEventPackage = <ThrowOnError extends boolean = false>(
  options?: Options<ShouldSubmitUnexpectedEventPackageData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ShouldSubmitUnexpectedEventPackageResponses,
    ShouldSubmitUnexpectedEventPackageErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/should-submit-unexpected-event-package',
    ...options,
  })
}

/**
 * Submit Vehicle Position
 * Submit a vehicle position data
 *
 * Body:
 * - position_data (VehiclePositionBatch): Vehicle position data
 *
 * Examples:
 * - position_data: {
 * "values": [
 * [1759395297.048396, 50.070575, 14.401332, 28.0, 0.91080730, 0.95, 0.89, 120.0],
 * [1759395297.048396, 50.070575, 14.401332, 28.0, 0.91080730, 0.95, 0.89, 120.0],
 * ...
 * ]
 * }
 * - values item:
 * [1759395297.048396, 50.070575, 14.401332, 28.0, 0.91080730, 0.95, 0.89, 120.0]
 * consists of:
 * - timestamp: Unix timestamp
 * - latitude: Latitude
 * - longitude: Longitude
 * - cno: CNO mean
 * - confidence: Confidence
 * - lon_std_dev: Longitude standard deviation [m]
 * - lat_std_dev: Latitude standard deviation [m]
 * - azimuth: Azimuth [deg]
 */
export const submitVehiclePosition = <ThrowOnError extends boolean = false>(
  options: Options<SubmitVehiclePositionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SubmitVehiclePositionResponses,
    SubmitVehiclePositionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/vehicle-position',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Drivers And Scheduled Shifts
 */
export const getDriversAndScheduledShifts = <ThrowOnError extends boolean = false>(
  options?: Options<GetDriversAndScheduledShiftsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetDriversAndScheduledShiftsResponses,
    GetDriversAndScheduledShiftsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/drivers',
    ...options,
  })
}

/**
 * Get Active Work Period
 */
export const getActiveWorkPeriod = <ThrowOnError extends boolean = false>(
  options?: Options<GetActiveWorkPeriodData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetActiveWorkPeriodResponses, GetActiveWorkPeriodErrors, ThrowOnError>({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/active-work-period',
    ...options,
  })
}

/**
 * Driver Sign In
 * Start a driver work period.
 */
export const driverSignIn = <ThrowOnError extends boolean = false>(
  options: Options<DriverSignInData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<DriverSignInResponses, DriverSignInErrors, ThrowOnError>({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/driver-sign-in/{driver_id}',
    ...options,
  })
}

/**
 * Driver Sign Out
 * Finish the current driver work period.
 */
export const driverSignOut = <ThrowOnError extends boolean = false>(
  options?: Options<DriverSignOutData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<DriverSignOutResponses, DriverSignOutErrors, ThrowOnError>({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/driver-sign-out',
    ...options,
  })
}

/**
 * Report Drive Started
 * Report that the car just started the drive.
 */
export const reportDriveStarted = <ThrowOnError extends boolean = false>(
  options: Options<ReportDriveStartedData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<ReportDriveStartedResponses, ReportDriveStartedErrors, ThrowOnError>({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/drives/{drive_id}/report-started',
    ...options,
  })
}

/**
 * Report Drive Finished
 * Report that the car just finished the drive.
 */
export const reportDriveFinished = <ThrowOnError extends boolean = false>(
  options: Options<ReportDriveFinishedData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<ReportDriveFinishedResponses, ReportDriveFinishedErrors, ThrowOnError>({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/drives/{drive_id}/report-finished',
    ...options,
  })
}

/**
 * Get Finished Drive Statistics
 * Fetch statistics for a finished drive.
 */
export const getFinishedDriveStatistics = <ThrowOnError extends boolean = false>(
  options: Options<GetFinishedDriveStatisticsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetFinishedDriveStatisticsResponses,
    GetFinishedDriveStatisticsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/drives/{drive_id}/statistics',
    ...options,
  })
}

/**
 * Schedule Freeride
 */
export const scheduleFreeride = <ThrowOnError extends boolean = false>(
  options?: Options<ScheduleFreerideData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<ScheduleFreerideResponses, ScheduleFreerideErrors, ThrowOnError>({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/schedule-freeride',
    ...options,
  })
}

/**
 * Post Compute Routes
 */
export const postComputeRoutes = <ThrowOnError extends boolean = false>(
  options: Options<PostComputeRoutesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<PostComputeRoutesResponses, PostComputeRoutesErrors, ThrowOnError>({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/directions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Empty Technical Segments
 */
export const getEmptyTechnicalSegments = <ThrowOnError extends boolean = false>(
  options?: Options<GetEmptyTechnicalSegmentsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetEmptyTechnicalSegmentsResponses,
    GetEmptyTechnicalSegmentsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/get-empty-technical-segments',
    ...options,
  })
}

/**
 * Submit Empty Technical Segment Evidence
 */
export const submitEmptyTechnicalSegmentEvidence = <ThrowOnError extends boolean = false>(
  options: Options<SubmitEmptyTechnicalSegmentEvidenceData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    SubmitEmptyTechnicalSegmentEvidenceResponses,
    SubmitEmptyTechnicalSegmentEvidenceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/submit-empty-technical-segment-evidence',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete Empty Technical Segments
 */
export const deleteEmptyTechnicalSegments = <ThrowOnError extends boolean = false>(
  options: Options<DeleteEmptyTechnicalSegmentsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteEmptyTechnicalSegmentsResponses,
    DeleteEmptyTechnicalSegmentsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/patrol/delete-empty-technical-segments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get All Planning Areas
 */
export const getAllPlanningAreas = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllPlanningAreasData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetAllPlanningAreasResponses, GetAllPlanningAreasErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/planning-areas',
    ...options,
  })
}

/**
 * Delete Planning Area
 * Permanently delete a planning area. This will fail if routes still exist in that area.
 */
export const deletePlanningArea = <ThrowOnError extends boolean = false>(
  options: Options<DeletePlanningAreaData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<DeletePlanningAreaResponses, DeletePlanningAreaErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/planning-areas/{area_id}',
    ...options,
  })
}

/**
 * Get Planning Area
 */
export const getPlanningArea = <ThrowOnError extends boolean = false>(
  options: Options<GetPlanningAreaData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetPlanningAreaResponses, GetPlanningAreaErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/planning-areas/{area_id}',
    ...options,
  })
}

/**
 * Update Planning Area
 */
export const updatePlanningArea = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePlanningAreaData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<UpdatePlanningAreaResponses, UpdatePlanningAreaErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/planning-areas/{area_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Create District
 */
export const createDistrict = <ThrowOnError extends boolean = false>(
  options: Options<CreateDistrictData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<CreateDistrictResponses, CreateDistrictErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/districts/{district_code}/{subdistrict_code}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Planning Data
 */
export const getPlanningData = <ThrowOnError extends boolean = false>(
  options: Options<GetPlanningDataData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetPlanningDataResponses, GetPlanningDataErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/planning-data/{area_id}',
    ...options,
  })
}

/**
 * Get District Map
 */
export const getDistrictMap = <ThrowOnError extends boolean = false>(
  options?: Options<GetDistrictMapData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetDistrictMapResponses, GetDistrictMapErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/district-map',
    ...options,
  })
}

/**
 * Get All Active Routes
 */
export const getAllActiveRoutes = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllActiveRoutesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetAllActiveRoutesResponses, GetAllActiveRoutesErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/routes',
    ...options,
  })
}

/**
 * Get Route Problems Summary
 */
export const getRouteProblemsSummary = <ThrowOnError extends boolean = false>(
  options?: Options<GetRouteProblemsSummaryData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetRouteProblemsSummaryResponses,
    GetRouteProblemsSummaryErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/route-problems-summary',
    ...options,
  })
}

/**
 * Get Routes In Area
 */
export const getRoutesInArea = <ThrowOnError extends boolean = false>(
  options: Options<GetRoutesInAreaData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetRoutesInAreaResponses, GetRoutesInAreaErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/routes/by-area/{area_id}',
    ...options,
  })
}

/**
 * Get Route Ts Coverage All
 * Evaluate route coverage for all planning areas against active routes and TS/RZ/SP.
 *
 * Returns a lightweight summary per planning area suitable for dashboards. The
 * detailed per-area breakdown remains available at `/route-ts-coverage/{planning_area_id}`.
 * When ``only_with_active_routes`` is true (default), only planning areas that have at
 * least one active route are included.
 */
export const getRouteTsCoverageAll = <ThrowOnError extends boolean = false>(
  options?: Options<GetRouteTsCoverageAllData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetRouteTsCoverageAllResponses,
    GetRouteTsCoverageAllErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/route-ts-coverage-all',
    ...options,
  })
}

/**
 * Get Route Ts Coverage
 * Check which technical segments in a planning area are covered by active routes.
 */
export const getRouteTsCoverage = <ThrowOnError extends boolean = false>(
  options: Options<GetRouteTsCoverageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetRouteTsCoverageResponses, GetRouteTsCoverageErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/route-ts-coverage/{planning_area_id}',
    ...options,
  })
}

/**
 * Check Route With Google Maps
 */
export const checkRouteWithGoogleMaps = <ThrowOnError extends boolean = false>(
  options: Options<CheckRouteWithGoogleMapsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    CheckRouteWithGoogleMapsResponses,
    CheckRouteWithGoogleMapsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/check-route-with-google-maps/{route_id}/{route_version}',
    ...options,
  })
}

/**
 * Validate Street Segment Geometry
 */
export const validateStreetSegmentGeometry = <ThrowOnError extends boolean = false>(
  options?: Options<ValidateStreetSegmentGeometryData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ValidateStreetSegmentGeometryResponses,
    ValidateStreetSegmentGeometryErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/validate-street-segment-geometry',
    ...options,
  })
}

/**
 * Delete Route
 * Permanently delete a route. This will fail if drive records for that route still exist.
 */
export const deleteRoute = <ThrowOnError extends boolean = false>(options: Options<DeleteRouteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<DeleteRouteResponses, DeleteRouteErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/routes/{route_id}/{route_version}',
    ...options,
  })
}

/**
 * Get Route
 */
export const getRoute = <ThrowOnError extends boolean = false>(options: Options<GetRouteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<GetRouteResponses, GetRouteErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/maps/routes/{route_id}/{route_version}',
    ...options,
  })
}

/**
 * Create Route
 */
export const createRoute = <ThrowOnError extends boolean = false>(options: Options<CreateRouteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<CreateRouteResponses, CreateRouteErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/routes/{route_id}/{route_version}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete Route Drives
 * Permanently delete all drive records for given route. This may lead to a loss of valuable billing data.
 */
export const deleteRouteDrives = <ThrowOnError extends boolean = false>(
  options: Options<DeleteRouteDrivesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<DeleteRouteDrivesResponses, DeleteRouteDrivesErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/routes/{route_id}/{route_version}/drives',
    ...options,
  })
}

/**
 * Update Route Fragments
 */
export const updateRouteFragments = <ThrowOnError extends boolean = false>(
  options: Options<UpdateRouteFragmentsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    UpdateRouteFragmentsResponses,
    UpdateRouteFragmentsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/routes/{route_id}/{route_version}/fragments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Autogenerate Route Fragments
 */
export const autogenerateRouteFragments = <ThrowOnError extends boolean = false>(
  options: Options<AutogenerateRouteFragmentsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    AutogenerateRouteFragmentsResponses,
    AutogenerateRouteFragmentsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/routes/{route_id}/{route_version}/fragments/autogenerate',
    ...options,
  })
}

/**
 * Get Street Segments In Polygon
 */
export const getStreetSegmentsInPolygon = <ThrowOnError extends boolean = false>(
  options: Options<GetStreetSegmentsInPolygonData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    GetStreetSegmentsInPolygonResponses,
    GetStreetSegmentsInPolygonErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/street-segments-in-polygon',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get District Planning Data
 */
export const getDistrictPlanningData = <ThrowOnError extends boolean = false>(
  options: Options<GetDistrictPlanningDataData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    GetDistrictPlanningDataResponses,
    GetDistrictPlanningDataErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/district-planning-data/{district_code}/{subdistrict_code}',
    ...options,
  })
}

/**
 * Get All Planning Data
 */
export const getAllPlanningData = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllPlanningDataData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<GetAllPlanningDataResponses, GetAllPlanningDataErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/all-planning-data',
    ...options,
  })
}

/**
 * Post Planning Data In Polygon
 */
export const postPlanningDataInPolygon = <ThrowOnError extends boolean = false>(
  options: Options<PostPlanningDataInPolygonData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PostPlanningDataInPolygonResponses,
    PostPlanningDataInPolygonErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/planning-data-in-polygon',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Override List
 */
export const getOverrideList = <ThrowOnError extends boolean = false>(
  options: Options<GetOverrideListData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetOverrideListResponses, GetOverrideListErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/overrides/{snapshot_name}',
    ...options,
  })
}

/**
 * Get Snapshot List
 */
export const getSnapshotList = <ThrowOnError extends boolean = false>(
  options?: Options<GetSnapshotListData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetSnapshotListResponses, GetSnapshotListErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/snapshots',
    ...options,
  })
}

/**
 * Get Snapshot List With Overrides
 */
export const getSnapshotListWithOverrides = <ThrowOnError extends boolean = false>(
  options?: Options<GetSnapshotListWithOverridesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetSnapshotListWithOverridesResponses,
    GetSnapshotListWithOverridesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/snapshots-with-overrides',
    ...options,
  })
}

/**
 * Compare Two Snapshots
 */
export const compareTwoSnapshots = <ThrowOnError extends boolean = false>(
  options: Options<CompareTwoSnapshotsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<CompareTwoSnapshotsResponses, CompareTwoSnapshotsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/compare-snapshots',
    ...options,
  })
}

/**
 * Get Street Segments
 */
export const getStreetSegments = <ThrowOnError extends boolean = false>(
  options?: Options<GetStreetSegmentsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetStreetSegmentsResponses, GetStreetSegmentsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/street-segments',
    ...options,
  })
}

/**
 * Get Tsk Segments
 */
export const getTskSegments = <ThrowOnError extends boolean = false>(
  options: Options<GetTskSegmentsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetTskSegmentsResponses, GetTskSegmentsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/tsk-segments/{snapshot_name}',
    ...options,
  })
}

/**
 * Get Requirements
 */
export const getRequirements = <ThrowOnError extends boolean = false>(
  options: Options<GetRequirementsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetRequirementsResponses, GetRequirementsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/requirements/{snapshot_name}',
    ...options,
  })
}

/**
 * Get Requirements Docu
 */
export const getRequirementsDocu = <ThrowOnError extends boolean = false>(
  options: Options<GetRequirementsDocuData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetRequirementsDocuResponses, GetRequirementsDocuErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/requirements-docu/{snapshot_name}',
    ...options,
  })
}

/**
 * Get Control Data Schemas
 */
export const getControlDataSchemas = <ThrowOnError extends boolean = false>(
  options?: Options<GetControlDataSchemasData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetControlDataSchemasResponses,
    GetControlDataSchemasErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/control-data-schemas',
    ...options,
  })
}

/**
 * Create Map Snapshot
 */
export const createMapSnapshot = <ThrowOnError extends boolean = false>(
  options: Options<CreateMapSnapshotData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<CreateMapSnapshotResponses, CreateMapSnapshotErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/create-remote-map-snapshot/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Current Snapshot
 */
export const getCurrentSnapshot = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentSnapshotData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetCurrentSnapshotResponses, GetCurrentSnapshotErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/current-snapshot',
    ...options,
  })
}

/**
 * Get Control Data Data Version
 */
export const getControlDataDataVersion = <ThrowOnError extends boolean = false>(
  options?: Options<GetControlDataDataVersionData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetControlDataDataVersionResponses,
    GetControlDataDataVersionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/control-data/data-version',
    ...options,
  })
}

/**
 * Sync Maps
 */
export const syncMaps = <ThrowOnError extends boolean = false>(options: Options<SyncMapsData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<SyncMapsResponses, SyncMapsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/sync-maps',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete Snapshot
 */
export const deleteSnapshot = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSnapshotData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<DeleteSnapshotResponses, DeleteSnapshotErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/delete-snapshot',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Sync Openstreetmaps
 */
export const syncOpenstreetmaps = <ThrowOnError extends boolean = false>(
  options: Options<SyncOpenstreetmapsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<SyncOpenstreetmapsResponses, SyncOpenstreetmapsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/sync-openstreetmaps',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Street Segment
 */
export const getStreetSegment = <ThrowOnError extends boolean = false>(
  options: Options<GetStreetSegmentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetStreetSegmentResponses, GetStreetSegmentErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/street-segments/{segment_id}',
    ...options,
  })
}

/**
 * Get Technical Segment
 */
export const getTechnicalSegment = <ThrowOnError extends boolean = false>(
  options: Options<GetTechnicalSegmentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetTechnicalSegmentResponses, GetTechnicalSegmentErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/technical-segments/{segment_id}',
    ...options,
  })
}

/**
 * Get Regulated Zone
 */
export const getRegulatedZone = <ThrowOnError extends boolean = false>(
  options: Options<GetRegulatedZoneData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetRegulatedZoneResponses, GetRegulatedZoneErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/regulated-zones/{zone_id}',
    ...options,
  })
}

/**
 * Get Sign Post
 */
export const getSignPost = <ThrowOnError extends boolean = false>(options: Options<GetSignPostData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<GetSignPostResponses, GetSignPostErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/maps/sign-posts/{post_id}',
    ...options,
  })
}

/**
 * Get Planning Area Splits
 */
export const getPlanningAreaSplits = <ThrowOnError extends boolean = false>(
  options: Options<GetPlanningAreaSplitsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetPlanningAreaSplitsResponses,
    GetPlanningAreaSplitsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/splits/planning-areas/{planning_area_id}',
    ...options,
  })
}

/**
 * Save Planning Area Splits
 */
export const savePlanningAreaSplits = <ThrowOnError extends boolean = false>(
  options: Options<SavePlanningAreaSplitsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    SavePlanningAreaSplitsResponses,
    SavePlanningAreaSplitsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/splits/planning-areas/{planning_area_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Splits District Planning Data
 */
export const getSplitsDistrictPlanningData = <ThrowOnError extends boolean = false>(
  options: Options<GetSplitsDistrictPlanningDataData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    GetSplitsDistrictPlanningDataResponses,
    GetSplitsDistrictPlanningDataErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/splits/district-planning-data/{district_code}/{subdistrict_code}',
    ...options,
  })
}

/**
 * Compute District Splits
 */
export const computeDistrictSplits = <ThrowOnError extends boolean = false>(
  options: Options<ComputeDistrictSplitsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ComputeDistrictSplitsResponses,
    ComputeDistrictSplitsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/splits/districts/{district_code}/{subdistrict_code}/compute-splits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Districts With Requested Segments
 */
export const getDistrictsWithRequestedSegments = <ThrowOnError extends boolean = false>(
  options?: Options<GetDistrictsWithRequestedSegmentsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetDistrictsWithRequestedSegmentsResponses,
    GetDistrictsWithRequestedSegmentsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/splits/districts-with-requested-segments',
    ...options,
  })
}

/**
 * Get Pending Recompute
 */
export const getPendingRecompute = <ThrowOnError extends boolean = false>(
  options?: Options<GetPendingRecomputeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetPendingRecomputeResponses, GetPendingRecomputeErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/splits/pending-recompute',
    ...options,
  })
}

/**
 * Get All Split Problems
 */
export const getAllSplitProblems = <ThrowOnError extends boolean = false>(
  options: Options<GetAllSplitProblemsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetAllSplitProblemsResponses, GetAllSplitProblemsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/splits/splitter/problems',
    ...options,
  })
}

/**
 * Get Ds Tariff Root Map
 */
export const getDsTariffRootMap = <ThrowOnError extends boolean = false>(
  options: Options<GetDsTariffRootMapData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetDsTariffRootMapResponses, GetDsTariffRootMapErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/splits/ds-tariff-root-map',
    ...options,
  })
}

/**
 * Get Ds Drive Times
 */
export const getDsDriveTimes = <ThrowOnError extends boolean = false>(
  options: Options<GetDsDriveTimesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetDsDriveTimesResponses, GetDsDriveTimesErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/splits/ds-drive-times/{year}',
    ...options,
  })
}

/**
 * Get Ds Drive Overview
 */
export const getDsDriveOverview = <ThrowOnError extends boolean = false>(
  options: Options<GetDsDriveOverviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetDsDriveOverviewResponses, GetDsDriveOverviewErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/splits/ds-drive-overview/{year}',
    ...options,
  })
}

/**
 * Get Ds Big Closures
 */
export const getDsBigClosures = <ThrowOnError extends boolean = false>(
  options: Options<GetDsBigClosuresData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetDsBigClosuresResponses, GetDsBigClosuresErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/splits/ds-big-closures/{year}',
    ...options,
  })
}

/**
 * Get Ds Route Map
 */
export const getDsRouteMap = <ThrowOnError extends boolean = false>(
  options?: Options<GetDsRouteMapData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetDsRouteMapResponses, GetDsRouteMapErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/splits/ds-route-map',
    ...options,
  })
}

/**
 * Routes Map Data
 */
export const routesMapData = <ThrowOnError extends boolean = false>(
  options?: Options<RoutesMapDataData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<RoutesMapDataResponses, RoutesMapDataErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/routes-map/data',
    ...options,
  })
}

/**
 * Routes Map Viewport
 */
export const routesMapViewport = <ThrowOnError extends boolean = false>(
  options: Options<RoutesMapViewportData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<RoutesMapViewportResponses, RoutesMapViewportErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/routes-map/viewport',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Routes Map Route Detail
 */
export const routesMapRouteDetail = <ThrowOnError extends boolean = false>(
  options: Options<RoutesMapRouteDetailData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<RoutesMapRouteDetailResponses, RoutesMapRouteDetailErrors, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/api/routes-map/route/{route_id}/{route_version}',
      ...options,
    }
  )
}

/**
 * Routes Map Search
 */
export const routesMapSearch = <ThrowOnError extends boolean = false>(
  options: Options<RoutesMapSearchData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<RoutesMapSearchResponses, RoutesMapSearchErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/routes-map/search',
    ...options,
  })
}

/**
 * Update Street Segment
 */
export const updateStreetSegment = <ThrowOnError extends boolean = false>(
  options: Options<UpdateStreetSegmentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<UpdateStreetSegmentResponses, UpdateStreetSegmentErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/update-street-segment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete Street Segment Override
 * Delete a street segment override (and the matching snapshot override row on the Prague instance).
 */
export const deleteStreetSegmentOverride = <ThrowOnError extends boolean = false>(
  options: Options<DeleteStreetSegmentOverrideData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteStreetSegmentOverrideResponses,
    DeleteStreetSegmentOverrideErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/override',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Upsert Street Segment Override
 * Upsert a street segment override.
 *
 * Overrides are applied on read by the street_segments / street_segment_drive_requirements views.
 * On the Prague instance the matching snapshot override row is upserted in the same transaction so
 * the control data and snapshot override hashes stay aligned.
 */
export const upsertStreetSegmentOverride = <ThrowOnError extends boolean = false>(
  options: Options<UpsertStreetSegmentOverrideData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    UpsertStreetSegmentOverrideResponses,
    UpsertStreetSegmentOverrideErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/override',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Update Technical Segment
 */
export const updateTechnicalSegment = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTechnicalSegmentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    UpdateTechnicalSegmentResponses,
    UpdateTechnicalSegmentErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/update-technical-segment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Update Regulated Zone
 */
export const updateRegulatedZone = <ThrowOnError extends boolean = false>(
  options: Options<UpdateRegulatedZoneData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<UpdateRegulatedZoneResponses, UpdateRegulatedZoneErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/update-regulated-zone',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Update Sign Post
 */
export const updateSignPost = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSignPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<UpdateSignPostResponses, UpdateSignPostErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/update-sign-post',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Update Control Data Structure
 */
export const updateControlDataStructure = <ThrowOnError extends boolean = false>(
  options?: Options<UpdateControlDataStructureData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    UpdateControlDataStructureResponses,
    UpdateControlDataStructureErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/update-control-data-structure',
    ...options,
  })
}

/**
 * Update To Override Based Control Data Structure
 * [TEMPORARY] Special, single purpose endpoint to update the control data structure
 * to the override-based control data structure.
 *
 * WARNING: This enpoint must be called exacly once AFTER updaging DB to alembic version
 * 2026-08-25_override_based_control_data_3f9c1e7a2b84 and BEFORE control data structure update endpoint.
 *
 * TODO: Remove this in the next version
 */
export const updateToOverrideBasedControlDataStructure = <ThrowOnError extends boolean = false>(
  options?: Options<UpdateToOverrideBasedControlDataStructureData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    UpdateToOverrideBasedControlDataStructureResponses,
    UpdateToOverrideBasedControlDataStructureErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/update-to-override-based-control-data-structure',
    ...options,
  })
}

/**
 * Rollback To Legacy Control Data Structure
 * [TEMPORARY] Special, single purpose endpoint to rollback from the override-based control data structure
 * to the legacy control data structure.
 *
 * WARNING: This enpoint must be called exacly once in case of rolling back before
 * 2026-08-25_override_based_control_data_3f9c1e7a2b84 AFTER downgrading DB and BEFORE control data structure
 * update endpoint.
 *
 * TODO: Remove this in the next version
 */
export const rollbackToLegacyControlDataStructure = <ThrowOnError extends boolean = false>(
  options?: Options<RollbackToLegacyControlDataStructureData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    RollbackToLegacyControlDataStructureResponses,
    RollbackToLegacyControlDataStructureErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/rollback-to-legacy-control-data-structure',
    ...options,
  })
}

/**
 * Copy And Update Control Data Structure
 */
export const copyAndUpdateControlDataStructure = <ThrowOnError extends boolean = false>(
  options: Options<CopyAndUpdateControlDataStructureData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CopyAndUpdateControlDataStructureResponses,
    CopyAndUpdateControlDataStructureErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/copy-and-update-control-data-structure',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Import Technical Segments Regulated Zones And Sign Posts
 * Update technical_segments, regulated_zones and sign_posts from geojson files
 * EP requires sign_post_file and either technical_segments_file or regulated_zones_file.
 * If both are provided, regulated_zones_file will be ignored.
 *
 * Params:
 * - append_only (bool, optional): Do not delete pre-existing data not present in the files,
 * defaults to False.
 * - invalid_geometry_handling (InvalidGeometryHandling, optional):
 * Ignore invalid geometries in the input data (i.e. parking spaces),
 * defaults to InvalidGeometryHandling.STRICT.
 *
 * Street pairing parameters (See Pairing Mechanism Overview for details):
 *
 * - segment_sample_length (float | None, optional): Segment sample length [m], defaults to 10m.
 * - init_proximity_distance (float | None, optional): Distance in which to look for street
 * segments [SRS unit], defaults to 0.0004.
 * - max_distance_avg (float | None, optional): Max distance to look for single perfect match
 * [SRS unit], defaults to 0.00008.
 *
 * Body:
 * - sign_posts_file (File|binary, "application/geojson"): Sign posts geojson.
 * - technical_segments_file (File|binary, "application/geojson", optional):
 * Technical segments geojson.
 * - regulated_zones_file (File|binary, "application/geojson", optional):
 * Regulated zones geojson.
 *
 * > **Pairing Mechanism Overview**
 * >
 * > The mechanism pairs technical segments with street segments by comparing their geometric
 * > similarity. Different datasets may require slightly different parameters to achieve the
 * > best results.
 * > Final metric for pairing success/confidence is the count of
 * > technical_segments.is_suspicious_pairing compared to total count of inserted/updated
 * > technical_segments (lower is better)
 * >
 * > Parameters:
 * > - **segment_sample_length** (default: 10.0):
 * >   Controls the density of sample points along both technical and street segment axes.
 * >   Higher values = fewer sample points, lower values = more detailed sampling
 * > - **init_proximity_distance** (default: 0.0004):
 * >   Initial spatial filter using ST_DWithin() to find candidate street segments.
 * >   Only street segments within this distance from the technical segment are considered.
 * >   Acts as a performance optimization to avoid comparing distant segments
 * > - **max_distance_avg** (default: 0.00008):
 * >   Final quality threshold for pairing decisions.
 * >   Compares average distance between sample points of technical and street segment axes.
 * >   Only pairs with distance_avg < max_distance_avg are considered valid.
 * >   Much smaller than init_proximity_distance for precise matching
 *
 * > Known parameter values:
 * > - Nitra: segment_sample_length=12.0, init_proximity_distance=0.0003,
 * >   max_distance_avg=0.000089
 * > - Prague: segment_sample_length=10, init_proximity_distance=0.0004,
 * >   max_distance_avg=0.00008
 * > - Bratislava: segment_sample_length=9, init_proximity_distance=0.0003,
 * >   max_distance_avg=0.000088
 * > this is based on empirical testing and is not guaranteed to be optimal for future datasets
 */
export const importTechnicalSegmentsRegulatedZonesAndSignPosts = <ThrowOnError extends boolean = false>(
  options: Options<ImportTechnicalSegmentsRegulatedZonesAndSignPostsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ImportTechnicalSegmentsRegulatedZonesAndSignPostsResponses,
    ImportTechnicalSegmentsRegulatedZonesAndSignPostsErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/import-trs',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  })
}

/**
 * Freeze Technical Segment Street Pairing
 * Freeze technical segment street pairing
 *
 * Freezes technical segments that are not suspicious and not already frozen.
 *
 * Params:
 * - district_id (int | None, optional): District ID. If present, freeze technical segments only for this district
 * - tariff_zone (str | None, optional): Tariff zone. If present, freeze technical segments only for this tariff zone
 *
 * Returns:
 * - SuccessResponse: Success response with the result message
 */
export const freezeTechnicalSegmentStreetPairing = <ThrowOnError extends boolean = false>(
  options?: Options<FreezeTechnicalSegmentStreetPairingData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    FreezeTechnicalSegmentStreetPairingResponses,
    FreezeTechnicalSegmentStreetPairingErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/freeze-technical-segment-street-pairing',
    ...options,
  })
}

/**
 * Pair Technical Segments2Street Segments
 * Pair technical segments to street segments
 *
 * for detailed description and optimal parameter values see
 * `/api/control-data-edit/import-trs` docs
 *
 * Params:
 * - dry (bool, optional): Dry run, set to False to persist the results, default=True
 * - limit_ts (int | None, optional): Limit the number of technical segments to pair
 * (incompatible with dry=False), default=None, gt=0
 * - segment_sample_length (float | None, optional): Segment sample length [m], defaults to 10m
 * - init_proximity_distance (float | None, optional): Distance in which to look for street
 * segments [SRS unit], defaults to 0.0004
 * - max_distance_avg (float | None, optional): Max distance to look for single perfect
 * match [SRS unit], defaults to 0.00008
 * - exclude_frozen (bool, optional): Exclude frozen technical segments, default=True
 * - district_id (int | None, optional): District ID. If present, pair technical segments only for this district
 * - tariff_zone (str | None, optional): Tariff zone. If present, pair technical segments only for this tariff zone
 *
 * Returns:
 * - SuccessResponse: Success response with the result message
 */
export const pairTechnicalSegments2StreetSegments = <ThrowOnError extends boolean = false>(
  options?: Options<PairTechnicalSegments2StreetSegmentsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    PairTechnicalSegments2StreetSegmentsResponses,
    PairTechnicalSegments2StreetSegmentsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/pair-technical-segments-street',
    ...options,
  })
}

/**
 * Compute Ssdr
 * Compute Street Segment Drive Requirements
 *
 * Params:
 * - db (DBSessionWithControlDataSchema): Database session
 * - settings (AppSettings): Application settings
 * - district_id (int | None, optional): District ID. If present, compute SSDR only for this district, default=None
 * - include_technical_segments (bool, optional): Include technical segments, default=True
 * - include_regulated_zones (bool, optional): Include regulated zones, default=True
 * - include_sign_posts (bool, optional): Include sign posts, default=True
 * - exclude_frozen (bool, optional): Exclude frozen SSDR, default=True
 * - rz_ssdr_mode (RegulatedZoneSSDRMode, optional): Regulated zone SSDR mode, default=SIGNLE_CANDIDATE
 *
 * Returns:
 * - SuccessResponse: Success response with the result message
 */
export const computeSsdr = <ThrowOnError extends boolean = false>(options?: Options<ComputeSsdrData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).post<ComputeSsdrResponses, ComputeSsdrErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/compute-street-segment-drive-requirements',
    ...options,
  })
}

/**
 * Compare Rows
 * Compare rows between two control_data_* schemas for a given table.
 *
 * Returns paginated diff rows with left_data and right_data for each row,
 * along with the total count of matching rows (before pagination).
 * Optional `columns` is a comma-separated list of column names to include.
 */
export const compareRows = <ThrowOnError extends boolean = false>(options: Options<CompareRowsData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<CompareRowsResponses, CompareRowsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/compare/rows',
    ...options,
  })
}

/**
 * Apply Compare Change
 * Apply a change (copy/update/delete) from one control_data_* schema to another.
 *
 * Production schema protection applies to the target schema only.
 */
export const applyCompareChange = <ThrowOnError extends boolean = false>(
  options: Options<ApplyCompareChangeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<ApplyCompareChangeResponses, ApplyCompareChangeErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/compare/apply',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Pull Control Data
 * Pull control data from the source schema to the target schema
 */
export const pullControlData = <ThrowOnError extends boolean = false>(
  options?: Options<PullControlDataData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<PullControlDataResponses, PullControlDataErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/pull-control-data',
    ...options,
  })
}

/**
 * Delete Control Data Schema
 * Delete (drop) the whole specified control_data_* schema.
 *
 * The production control data schema is protected and cannot be deleted.
 */
export const deleteControlDataSchema = <ThrowOnError extends boolean = false>(
  options: Options<DeleteControlDataSchemaData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteControlDataSchemaResponses,
    DeleteControlDataSchemaErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/control-data-edit/schema',
    ...options,
  })
}

/**
 * Get All Vehicles
 */
export const getAllVehicles = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllVehiclesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetAllVehiclesResponses, GetAllVehiclesErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/vehicles',
    ...options,
  })
}

/**
 * Get Vehicle
 */
export const getVehicle = <ThrowOnError extends boolean = false>(options: Options<GetVehicleData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<GetVehicleResponses, GetVehicleErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/vehicles/{vehicle_id}',
    ...options,
  })
}

/**
 * Update Vehicle
 */
export const updateVehicle = <ThrowOnError extends boolean = false>(
  options: Options<UpdateVehicleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<UpdateVehicleResponses, UpdateVehicleErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/vehicles/{vehicle_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Vehicle Last Status
 */
export const getVehicleLastStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetVehicleLastStatusData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetVehicleLastStatusResponses, GetVehicleLastStatusErrors, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/api/drive-management/vehicles/{vehicle_id}/last-status',
      ...options,
    }
  )
}

/**
 * Get Vehicle Metrics
 */
export const getVehicleMetrics = <ThrowOnError extends boolean = false>(
  options: Options<GetVehicleMetricsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetVehicleMetricsResponses, GetVehicleMetricsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/vehicles/{vehicle_id}/metrics',
    ...options,
  })
}

/**
 * Get Vehicle Navigation Data
 */
export const getVehicleNavigationData = <ThrowOnError extends boolean = false>(
  options: Options<GetVehicleNavigationDataData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetVehicleNavigationDataResponses,
    GetVehicleNavigationDataErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/vehicles/{vehicle_id}/navigation-data',
    ...options,
  })
}

/**
 * Set Vehicle Maintenance Mode
 */
export const setVehicleMaintenanceMode = <ThrowOnError extends boolean = false>(
  options: Options<SetVehicleMaintenanceModeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    SetVehicleMaintenanceModeResponses,
    SetVehicleMaintenanceModeErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/vehicles/{vehicle_id}/maintenance-mode',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get All Drivers
 */
export const getAllDrivers = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllDriversData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetAllDriversResponses, GetAllDriversErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/drivers',
    ...options,
  })
}

/**
 * Create Driver
 */
export const createDriver = <ThrowOnError extends boolean = false>(
  options: Options<CreateDriverData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<CreateDriverResponses, CreateDriverErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/drivers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get External Drivers
 */
export const getExternalDrivers = <ThrowOnError extends boolean = false>(
  options?: Options<GetExternalDriversData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetExternalDriversResponses, GetExternalDriversErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/drivers/external',
    ...options,
  })
}

/**
 * Import External Driver
 */
export const importExternalDriver = <ThrowOnError extends boolean = false>(
  options: Options<ImportExternalDriverData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ImportExternalDriverResponses,
    ImportExternalDriverErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/drivers/import-external/{external_id}',
    ...options,
  })
}

/**
 * Associate External Driver
 */
export const associateExternalDriver = <ThrowOnError extends boolean = false>(
  options: Options<AssociateExternalDriverData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    AssociateExternalDriverResponses,
    AssociateExternalDriverErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/drivers/associate-external',
    ...options,
  })
}

/**
 * Get Driver
 */
export const getDriver = <ThrowOnError extends boolean = false>(options: Options<GetDriverData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<GetDriverResponses, GetDriverErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/drivers/{driver_id}',
    ...options,
  })
}

/**
 * Update Driver
 */
export const updateDriver = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDriverData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<UpdateDriverResponses, UpdateDriverErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/drivers/{driver_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Inactive Drivers
 */
export const getInactiveDrivers = <ThrowOnError extends boolean = false>(
  options?: Options<GetInactiveDriversData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetInactiveDriversResponses, GetInactiveDriversErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/inactive-drivers',
    ...options,
  })
}

/**
 * Get Daily Schedule
 */
export const getDailySchedule = <ThrowOnError extends boolean = false>(
  options: Options<GetDailyScheduleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetDailyScheduleResponses, GetDailyScheduleErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/daily-schedule/{schedule_date}',
    ...options,
  })
}

/**
 * Get Schedule For Interval
 */
export const getScheduleForInterval = <ThrowOnError extends boolean = false>(
  options: Options<GetScheduleForIntervalData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetScheduleForIntervalResponses,
    GetScheduleForIntervalErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/schedule/{interval_start}/{interval_end}',
    ...options,
  })
}

/**
 * Get Shift Overview
 */
export const getShiftOverview = <ThrowOnError extends boolean = false>(
  options: Options<GetShiftOverviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetShiftOverviewResponses, GetShiftOverviewErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/shift-overview/{billing_period_id}',
    ...options,
  })
}

/**
 * Delete Shift
 */
export const deleteShift = <ThrowOnError extends boolean = false>(options: Options<DeleteShiftData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<DeleteShiftResponses, DeleteShiftErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/shifts/{shift_id}',
    ...options,
  })
}

/**
 * Get Scheduled Drives
 * Get currently scheduled drives, grouped into intervals based on their time requirements.
 * The intervals are guaranteed to have no gaps between them (there may be intervals with no drives).
 */
export const getScheduledDrives = <ThrowOnError extends boolean = false>(
  options?: Options<GetScheduledDrivesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetScheduledDrivesResponses, GetScheduledDrivesErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/scheduled-drives',
    ...options,
  })
}

/**
 * Schedule Drive
 */
export const scheduleDrive = <ThrowOnError extends boolean = false>(
  options: Options<ScheduleDriveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<ScheduleDriveResponses, ScheduleDriveErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/scheduled-drives',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Scheduled Drive
 */
export const getScheduledDrive = <ThrowOnError extends boolean = false>(
  options: Options<GetScheduledDriveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetScheduledDriveResponses, GetScheduledDriveErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/scheduled-drive/{drive_id}',
    ...options,
  })
}

/**
 * Update Scheduled Drive
 */
export const updateScheduledDrive = <ThrowOnError extends boolean = false>(
  options: Options<UpdateScheduledDriveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<UpdateScheduledDriveResponses, UpdateScheduledDriveErrors, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/api/drive-management/scheduled-drives/{drive_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    }
  )
}

/**
 * Reorder Scheduled Drives
 */
export const reorderScheduledDrives = <ThrowOnError extends boolean = false>(
  options: Options<ReorderScheduledDrivesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ReorderScheduledDrivesResponses,
    ReorderScheduledDrivesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/scheduled-drives/reorder',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Reschedule Drive
 */
export const rescheduleDrive = <ThrowOnError extends boolean = false>(
  options: Options<RescheduleDriveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<RescheduleDriveResponses, RescheduleDriveErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/scheduled-drives/reschedule',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Move Schedule
 */
export const moveSchedule = <ThrowOnError extends boolean = false>(
  options: Options<MoveScheduleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<MoveScheduleResponses, MoveScheduleErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/scheduled-drives/move-schedule',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Current Drives
 */
export const getCurrentDrives = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentDrivesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetCurrentDrivesResponses, GetCurrentDrivesErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/scheduled-drives/current-drives',
    ...options,
  })
}

/**
 * Cancel Scheduled Drive
 */
export const cancelScheduledDrive = <ThrowOnError extends boolean = false>(
  options: Options<CancelScheduledDriveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CancelScheduledDriveResponses,
    CancelScheduledDriveErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/scheduled-drives/{drive_id}/cancel',
    ...options,
  })
}

/**
 * Approve Scheduled Drive
 */
export const approveScheduledDrive = <ThrowOnError extends boolean = false>(
  options: Options<ApproveScheduledDriveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ApproveScheduledDriveResponses,
    ApproveScheduledDriveErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/scheduled-drives/{drive_id}/approve',
    ...options,
  })
}

/**
 * Disapprove Scheduled Drive
 */
export const disapproveScheduledDrive = <ThrowOnError extends boolean = false>(
  options: Options<DisapproveScheduledDriveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    DisapproveScheduledDriveResponses,
    DisapproveScheduledDriveErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/scheduled-drives/{drive_id}/disapprove',
    ...options,
  })
}

/**
 * Get Drive Intervals
 */
export const getDriveIntervals = <ThrowOnError extends boolean = false>(
  options: Options<GetDriveIntervalsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetDriveIntervalsResponses, GetDriveIntervalsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/drive-intervals/{billing_period_id}',
    ...options,
  })
}

/**
 * Get Requirement Subintervals
 */
export const getRequirementSubintervals = <ThrowOnError extends boolean = false>(
  options: Options<GetRequirementSubintervalsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetRequirementSubintervalsResponses,
    GetRequirementSubintervalsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/drive-intervals/{billing_period_id}/requirement-subintervals/{starting_from}/{ending_at}',
    ...options,
  })
}

/**
 * Get Requirement Fulfillment Per Segment
 */
export const getRequirementFulfillmentPerSegment = <ThrowOnError extends boolean = false>(
  options: Options<GetRequirementFulfillmentPerSegmentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetRequirementFulfillmentPerSegmentResponses,
    GetRequirementFulfillmentPerSegmentErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/requirement-fulfillment/{billing_period_id}/per-segment/{requirements_id}/{timestamp}',
    ...options,
  })
}

/**
 * Get Requirement Fulfillment
 */
export const getRequirementFulfillment = <ThrowOnError extends boolean = false>(
  options: Options<GetRequirementFulfillmentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetRequirementFulfillmentResponses,
    GetRequirementFulfillmentErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/requirement-fulfillment/{billing_period_id}/{timestamp}',
    ...options,
  })
}

/**
 * Sync Shifts On Demand
 */
export const syncShiftsOnDemand = <ThrowOnError extends boolean = false>(
  options?: Options<SyncShiftsOnDemandData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<SyncShiftsOnDemandResponses, SyncShiftsOnDemandErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/sync-shifts',
    ...options,
  })
}

/**
 * Get Ping Vehicle
 */
export const getPingVehicle = <ThrowOnError extends boolean = false>(
  options: Options<GetPingVehicleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetPingVehicleResponses, GetPingVehicleErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-management/ping/{vehicle_id}',
    ...options,
  })
}

/**
 * Populate Interval
 */
export const populateInterval = <ThrowOnError extends boolean = false>(
  options: Options<PopulateIntervalData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<PopulateIntervalResponses, PopulateIntervalErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/scheduling/populate-interval',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Manually Populate Interval
 */
export const manuallyPopulateInterval = <ThrowOnError extends boolean = false>(
  options: Options<ManuallyPopulateIntervalData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ManuallyPopulateIntervalResponses,
    ManuallyPopulateIntervalErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/scheduling/manually-populate-interval',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Schedule Districts
 */
export const scheduleDistricts = <ThrowOnError extends boolean = false>(
  options: Options<ScheduleDistrictsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<ScheduleDistrictsResponses, ScheduleDistrictsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/scheduling/schedule-districts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Copy Vehicle Schedule
 */
export const copyVehicleSchedule = <ThrowOnError extends boolean = false>(
  options: Options<CopyVehicleScheduleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<CopyVehicleScheduleResponses, CopyVehicleScheduleErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/scheduling/copy-vehicle-schedule',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Schedule Documentation Day
 */
export const scheduleDocumentationDay = <ThrowOnError extends boolean = false>(
  options: Options<ScheduleDocumentationDayData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ScheduleDocumentationDayResponses,
    ScheduleDocumentationDayErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/scheduling/schedule-documentation/{billing_period_id}/{date}',
    ...options,
  })
}

/**
 * Schedule Documentation Month
 */
export const scheduleDocumentationMonth = <ThrowOnError extends boolean = false>(
  options: Options<ScheduleDocumentationMonthData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ScheduleDocumentationMonthResponses,
    ScheduleDocumentationMonthErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/scheduling/schedule-documentation/{billing_period_id}',
    ...options,
  })
}

/**
 * Schedule Itst Day
 */
export const scheduleItstDay = <ThrowOnError extends boolean = false>(
  options: Options<ScheduleItstDayData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<ScheduleItstDayResponses, ScheduleItstDayErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/scheduling/schedule-itst/{billing_period_id}/{date}',
    ...options,
  })
}

/**
 * Schedule Itst Month
 */
export const scheduleItstMonth = <ThrowOnError extends boolean = false>(
  options: Options<ScheduleItstMonthData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<ScheduleItstMonthResponses, ScheduleItstMonthErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/scheduling/schedule-itst/{billing_period_id}',
    ...options,
  })
}

/**
 * Apply Ds Plan Endpoint
 */
export const applyDsPlanEndpoint = <ThrowOnError extends boolean = false>(
  options: Options<ApplyDsPlanEndpointData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<ApplyDsPlanEndpointResponses, ApplyDsPlanEndpointErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/scheduling/apply-ds-plan',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Drives By Date
 */
export const getDrivesByDate = <ThrowOnError extends boolean = false>(
  options: Options<GetDrivesByDateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetDrivesByDateResponses, GetDrivesByDateErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/drives/{date}',
    ...options,
  })
}

/**
 * Get Daily Drive Overview
 */
export const getDailyDriveOverview = <ThrowOnError extends boolean = false>(
  options: Options<GetDailyDriveOverviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetDailyDriveOverviewResponses,
    GetDailyDriveOverviewErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/daily-drive-overview/{vehicle_id}/{date}',
    ...options,
  })
}

/**
 * Get Scheduled Drive Statistics
 * Get statistics of a single scheduled drive
 */
export const getScheduledDriveStatistics = <ThrowOnError extends boolean = false>(
  options: Options<GetScheduledDriveStatisticsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetScheduledDriveStatisticsResponses,
    GetScheduledDriveStatisticsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/detail/{drive_id}',
    ...options,
  })
}

/**
 * Get Package Submission Detail
 * Get package submission statistics of a single scheduled drive
 */
export const getPackageSubmissionDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetPackageSubmissionDetailData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetPackageSubmissionDetailResponses,
    GetPackageSubmissionDetailErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/package-submission-detail/{drive_id}',
    ...options,
  })
}

/**
 * Get Detailed Drive Statistics
 */
export const getDetailedDriveStatistics = <ThrowOnError extends boolean = false>(
  options: Options<GetDetailedDriveStatisticsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetDetailedDriveStatisticsResponses,
    GetDetailedDriveStatisticsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/detail/{timestamp_from}/{timestamp_to}',
    ...options,
  })
}

/**
 * Get Driver Statistics
 */
export const getDriverStatistics = <ThrowOnError extends boolean = false>(
  options: Options<GetDriverStatisticsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetDriverStatisticsResponses, GetDriverStatisticsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/drivers/{timestamp_from}/{timestamp_to}',
    ...options,
  })
}

/**
 * Get Elapsed Driver Time
 */
export const getElapsedDriverTime = <ThrowOnError extends boolean = false>(
  options: Options<GetElapsedDriverTimeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetElapsedDriverTimeResponses, GetElapsedDriverTimeErrors, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/api/drive-statistics/elapsed-driver-time/{billing_period_id}',
      ...options,
    }
  )
}

/**
 * Get All Route Statistics
 */
export const getAllRouteStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllRouteStatisticsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAllRouteStatisticsResponses,
    GetAllRouteStatisticsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/route-statistics',
    ...options,
  })
}

/**
 * Get District Overhead Statistics
 */
export const getDistrictOverheadStatistics = <ThrowOnError extends boolean = false>(
  options: Options<GetDistrictOverheadStatisticsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetDistrictOverheadStatisticsResponses,
    GetDistrictOverheadStatisticsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/district-overhead-statistics/{billing_period_id}',
    ...options,
  })
}

/**
 * Get Route Statistics
 */
export const getRouteStatistics = <ThrowOnError extends boolean = false>(
  options: Options<GetRouteStatisticsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetRouteStatisticsResponses, GetRouteStatisticsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/route-statistics/{route_id}/{route_version}',
    ...options,
  })
}

/**
 * Get Operation Metrics
 */
export const getOperationMetrics = <ThrowOnError extends boolean = false>(
  options: Options<GetOperationMetricsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetOperationMetricsResponses, GetOperationMetricsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/operation-metrics/{interval_start}/{interval_end}',
    ...options,
  })
}

/**
 * Get Operation Report Drivers
 */
export const getOperationReportDrivers = <ThrowOnError extends boolean = false>(
  options: Options<GetOperationReportDriversData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetOperationReportDriversResponses,
    GetOperationReportDriversErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/operation-report/drivers/{started_after}/{finished_before}',
    ...options,
  })
}

/**
 * Get Operation Report Routes
 */
export const getOperationReportRoutes = <ThrowOnError extends boolean = false>(
  options: Options<GetOperationReportRoutesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetOperationReportRoutesResponses,
    GetOperationReportRoutesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/operation-report/routes/{started_after}/{finished_before}',
    ...options,
  })
}

/**
 * Get Detection Comparison First Drives
 * List drives selectable as the first drive of a detection comparison
 */
export const getDetectionComparisonFirstDrives = <ThrowOnError extends boolean = false>(
  options?: Options<GetDetectionComparisonFirstDrivesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetDetectionComparisonFirstDrivesResponses,
    GetDetectionComparisonFirstDrivesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/detection-comparison/first-drives',
    ...options,
  })
}

/**
 * Get Detection Comparison Second Drives
 * List drives of the first drive's route selectable as the second drive of a detection comparison
 */
export const getDetectionComparisonSecondDrives = <ThrowOnError extends boolean = false>(
  options: Options<GetDetectionComparisonSecondDrivesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetDetectionComparisonSecondDrivesResponses,
    GetDetectionComparisonSecondDrivesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/detection-comparison/second-drives',
    ...options,
  })
}

/**
 * Get Detection Comparison
 * Match vehicle detections of two drives by plate and position
 */
export const getDetectionComparison = <ThrowOnError extends boolean = false>(
  options: Options<GetDetectionComparisonData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetDetectionComparisonResponses,
    GetDetectionComparisonErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/detection-comparison/{first_drive_id}/{second_drive_id}',
    ...options,
  })
}

/**
 * Get Drive Events
 */
export const getDriveEvents = <ThrowOnError extends boolean = false>(
  options: Options<GetDriveEventsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetDriveEventsResponses, GetDriveEventsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/{drive_id}/events',
    ...options,
  })
}

/**
 * Get Driven Street Segments
 */
export const getDrivenStreetSegments = <ThrowOnError extends boolean = false>(
  options: Options<GetDrivenStreetSegmentsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetDrivenStreetSegmentsResponses,
    GetDrivenStreetSegmentsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/{drive_id}/driven-segments',
    ...options,
  })
}

/**
 * Get Parking Sign Detection Count
 */
export const getParkingSignDetectionCount = <ThrowOnError extends boolean = false>(
  options: Options<GetParkingSignDetectionCountData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetParkingSignDetectionCountResponses,
    GetParkingSignDetectionCountErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/parking-sign-detection-count/{timestamp_from}/{timestamp_to}',
    ...options,
  })
}

/**
 * Get Technical Segment Detection Count
 */
export const getTechnicalSegmentDetectionCount = <ThrowOnError extends boolean = false>(
  options: Options<GetTechnicalSegmentDetectionCountData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetTechnicalSegmentDetectionCountResponses,
    GetTechnicalSegmentDetectionCountErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/technical-segment-detection-count/{timestamp_from}/{timestamp_to}',
    ...options,
  })
}

/**
 * Get Documentation Overview
 */
export const getDocumentationOverview = <ThrowOnError extends boolean = false>(
  options: Options<GetDocumentationOverviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetDocumentationOverviewResponses,
    GetDocumentationOverviewErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/drive-statistics/documentation-overview/{billing_period_id}',
    ...options,
  })
}

/**
 * Get Sign Post Confidences
 * Best image confidence statistics of sign post detections observed in [timestamp_from, timestamp_to),
 * split by camera mode (day/night). Sign posts from the control data that were not detected are included
 * with zero detection count.
 */
export const getSignPostConfidences = <ThrowOnError extends boolean = false>(
  options: Options<GetSignPostConfidencesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetSignPostConfidencesResponses,
    GetSignPostConfidencesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/confidence/sign-posts/{timestamp_from}/{timestamp_to}',
    ...options,
  })
}

/**
 * Get Tasks
 */
export const getTasks = <ThrowOnError extends boolean = false>(options?: Options<GetTasksData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetTasksResponses, GetTasksErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/tasks',
    ...options,
  })
}

/**
 * Get Tasks For Interval
 */
export const getTasksForInterval = <ThrowOnError extends boolean = false>(
  options: Options<GetTasksForIntervalData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetTasksForIntervalResponses, GetTasksForIntervalErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/tasks-for-interval/{starting_from}/{ending_at}',
    ...options,
  })
}

/**
 * Get All Billing Periods
 */
export const getAllBillingPeriods = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllBillingPeriodsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAllBillingPeriodsResponses,
    GetAllBillingPeriodsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/billing-periods',
    ...options,
  })
}

/**
 * Create Billing Period
 */
export const createBillingPeriod = <ThrowOnError extends boolean = false>(
  options: Options<CreateBillingPeriodData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<CreateBillingPeriodResponses, CreateBillingPeriodErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/billing-periods',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Task Billing Periods
 */
export const getTaskBillingPeriods = <ThrowOnError extends boolean = false>(
  options: Options<GetTaskBillingPeriodsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetTaskBillingPeriodsResponses,
    GetTaskBillingPeriodsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/tasks/{task_id}/billing-periods',
    ...options,
  })
}

/**
 * Delete Billing Period
 */
export const deleteBillingPeriod = <ThrowOnError extends boolean = false>(
  options: Options<DeleteBillingPeriodData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteBillingPeriodResponses,
    DeleteBillingPeriodErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/billing-periods/{billing_period_id}',
    ...options,
  })
}

/**
 * Get Billing Period Detail
 */
export const getBillingPeriodDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetBillingPeriodDetailData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetBillingPeriodDetailResponses,
    GetBillingPeriodDetailErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/billing-periods/{billing_period_id}',
    ...options,
  })
}

/**
 * Update Billing Period
 */
export const updateBillingPeriod = <ThrowOnError extends boolean = false>(
  options: Options<UpdateBillingPeriodData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<UpdateBillingPeriodResponses, UpdateBillingPeriodErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/billing-periods/{billing_period_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Update Billing Period Prices
 */
export const updateBillingPeriodPrices = <ThrowOnError extends boolean = false>(
  options: Options<UpdateBillingPeriodPricesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateBillingPeriodPricesResponses,
    UpdateBillingPeriodPricesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/billing-periods/{billing_period_id}/prices',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Import Order
 */
export const importOrder = <ThrowOnError extends boolean = false>(options: Options<ImportOrderData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<ImportOrderResponses, ImportOrderErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/billing-periods/{billing_period_id}/import-order',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  })
}

/**
 * Get Drive Billing Data
 */
export const getDriveBillingData = <ThrowOnError extends boolean = false>(
  options: Options<GetDriveBillingDataData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetDriveBillingDataResponses, GetDriveBillingDataErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/drive-billing-data/{scheduled_drive_id}',
    ...options,
  })
}

/**
 * Get Billing Audit Data
 */
export const getBillingAuditData = <ThrowOnError extends boolean = false>(
  options: Options<GetBillingAuditDataData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetBillingAuditDataResponses, GetBillingAuditDataErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/billing-audit-data/csv/{billing_period_id}',
    ...options,
  })
}

/**
 * Get Billed Amount History
 */
export const getBilledAmountHistory = <ThrowOnError extends boolean = false>(
  options: Options<GetBilledAmountHistoryData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetBilledAmountHistoryResponses,
    GetBilledAmountHistoryErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/billed-amount-history/{billing_period_id}',
    ...options,
  })
}

/**
 * Get Invoice Detail
 */
export const getInvoiceDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetInvoiceDetailData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetInvoiceDetailResponses, GetInvoiceDetailErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/invoice-detail/{billing_period_id}',
    ...options,
  })
}

/**
 * Get Invoice Detail Csv
 */
export const getInvoiceDetailCsv = <ThrowOnError extends boolean = false>(
  options: Options<GetInvoiceDetailCsvData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetInvoiceDetailCsvResponses, GetInvoiceDetailCsvErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/invoice-detail/csv/{billing_period_id}',
    ...options,
  })
}

/**
 * Get Invoice Csv
 */
export const getInvoiceCsv = <ThrowOnError extends boolean = false>(
  options: Options<GetInvoiceCsvData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetInvoiceCsvResponses, GetInvoiceCsvErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/invoice/csv/{billing_period_id}',
    ...options,
  })
}

/**
 * Get Invoice Csv Totals
 */
export const getInvoiceCsvTotals = <ThrowOnError extends boolean = false>(
  options: Options<GetInvoiceCsvTotalsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetInvoiceCsvTotalsResponses, GetInvoiceCsvTotalsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/invoice-totals/csv/{billing_period_id}',
    ...options,
  })
}

/**
 * Get Street Segment Audit Data
 */
export const getStreetSegmentAuditData = <ThrowOnError extends boolean = false>(
  options: Options<GetStreetSegmentAuditDataData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetStreetSegmentAuditDataResponses,
    GetStreetSegmentAuditDataErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/street-segment-audit-data/csv/{billing_period_id}',
    ...options,
  })
}

/**
 * Get Technical Segment Audit Data
 */
export const getTechnicalSegmentAuditData = <ThrowOnError extends boolean = false>(
  options: Options<GetTechnicalSegmentAuditDataData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetTechnicalSegmentAuditDataResponses,
    GetTechnicalSegmentAuditDataErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/technical-segment-audit-data/csv/{billing_period_id}',
    ...options,
  })
}

/**
 * Get Invoice Attachment Zip
 */
export const getInvoiceAttachmentZip = <ThrowOnError extends boolean = false>(
  options: Options<GetInvoiceAttachmentZipData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetInvoiceAttachmentZipResponses,
    GetInvoiceAttachmentZipErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/billing/invoice-attachment/zip/{billing_period_id}',
    ...options,
  })
}

/**
 * Get Metrics
 * Retrieve Prometheus metrics
 */
export const getMetrics = <ThrowOnError extends boolean = false>(options?: Options<GetMetricsData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetMetricsResponses, GetMetricsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/metrics',
    ...options,
  })
}

/**
 * Check Health
 */
export const checkHealth = <ThrowOnError extends boolean = false>(options?: Options<CheckHealthData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<CheckHealthResponses, CheckHealthErrors, ThrowOnError>({
    url: '/health',
    ...options,
  })
}

/**
 * Authenticate User
 */
export const authenticateUser = <ThrowOnError extends boolean = false>(
  options: Options<AuthenticateUserData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<AuthenticateUserResponses, AuthenticateUserErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/api/auth/token',
    ...options,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...options.headers,
    },
  })
}

/**
 * Refresh Token
 */
export const refreshToken = <ThrowOnError extends boolean = false>(
  options?: Options<RefreshTokenData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<RefreshTokenResponses, RefreshTokenErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/auth/token/refresh',
    ...options,
  })
}

/**
 * Introspect User
 */
export const introspectUser = <ThrowOnError extends boolean = false>(
  options?: Options<IntrospectUserData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<IntrospectUserResponses, IntrospectUserErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/auth/me',
    ...options,
  })
}

/**
 * Change Own Password
 */
export const changeOwnPassword = <ThrowOnError extends boolean = false>(
  options: Options<ChangeOwnPasswordData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<ChangeOwnPasswordResponses, ChangeOwnPasswordErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/auth/change-own-password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Log Evidence Submission
 */
export const logEvidenceSubmission = <ThrowOnError extends boolean = false>(
  options: Options<LogEvidenceSubmissionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LogEvidenceSubmissionResponses,
    LogEvidenceSubmissionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/cis/log-evidence-submission',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Event Payload
 */
export const getEventPayload = <ThrowOnError extends boolean = false>(
  options: Options<GetEventPayloadData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetEventPayloadResponses, GetEventPayloadErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/cis/event-payload/{cis_event_id}',
    ...options,
  })
}

/**
 * Get Package Scores
 */
export const getPackageScores = <ThrowOnError extends boolean = false>(
  options: Options<GetPackageScoresData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetPackageScoresResponses, GetPackageScoresErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/cis/package-scores/{day}.csv.gz',
    ...options,
  })
}

/**
 * Get Pass Request
 */
export const getPassRequest = <ThrowOnError extends boolean = false>(
  options?: Options<GetPassRequestData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetPassRequestResponses, GetPassRequestErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/cis/get-pass-request-data',
    ...options,
  })
}

/**
 * Resubmit Events
 * Time limits form a open-close interval (received_after inclusive, received_before exclusive).
 * Both status code limits are inclusive.
 */
export const resubmitEvents = <ThrowOnError extends boolean = false>(
  options: Options<ResubmitEventsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<ResubmitEventsResponses, ResubmitEventsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/cis/resubmit-events',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * [Deprecated] Get Map Schema Snapshot Version
 * @deprecated
 */
export const deprecatedGetMapSchemaSnapshotVersion = <ThrowOnError extends boolean = false>(
  options: Options<DeprecatedGetMapSchemaSnapshotVersionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    DeprecatedGetMapSchemaSnapshotVersionResponses,
    DeprecatedGetMapSchemaSnapshotVersionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/vehicle-admin/map-schema/snapshot-version/{map_schema}',
    ...options,
  })
}

/**
 * Get Control Data Version
 */
export const getControlDataVersion = <ThrowOnError extends boolean = false>(
  options: Options<GetControlDataVersionData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetControlDataVersionResponses,
    GetControlDataVersionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/vehicle-admin/control-data/version/{control_data_schema}',
    ...options,
  })
}

/**
 * Get Control Data Contents
 */
export const getControlDataContents = <ThrowOnError extends boolean = false>(
  options: Options<GetControlDataContentsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetControlDataContentsResponses,
    GetControlDataContentsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/vehicle-admin/control-data/contents/{control_data_schema}',
    ...options,
  })
}

/**
 * [Deprecated] Get Map Schema Contents
 * @deprecated
 */
export const deprecatedGetMapSchemaContents = <ThrowOnError extends boolean = false>(
  options: Options<DeprecatedGetMapSchemaContentsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    DeprecatedGetMapSchemaContentsResponses,
    DeprecatedGetMapSchemaContentsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/vehicle-admin/map-schema/contents/{control_data_schema}',
    ...options,
  })
}

/**
 * Get All Unexpected Events
 * Get all UEs, but not those, that have no latitude/longitude in `patrol_vehicle.position`.
 */
export const getAllUnexpectedEvents = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllUnexpectedEventsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAllUnexpectedEventsResponses,
    GetAllUnexpectedEventsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/unexpected-events/all-events',
    ...options,
  })
}

/**
 * Get Pending Unexpected Events
 * Get all pending UEs, but not those, that have no latitude/longitude in `patrol_vehicle.position`.
 */
export const getPendingUnexpectedEvents = <ThrowOnError extends boolean = false>(
  options?: Options<GetPendingUnexpectedEventsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetPendingUnexpectedEventsResponses,
    GetPendingUnexpectedEventsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/unexpected-events/pending-events',
    ...options,
  })
}

/**
 * Get Archived Unexpected Events
 * Get all processed/archived UEs, but not those, that have no latitude/longitude in `patrol_vehicle.position`.
 */
export const getArchivedUnexpectedEvents = <ThrowOnError extends boolean = false>(
  options?: Options<GetArchivedUnexpectedEventsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetArchivedUnexpectedEventsResponses,
    GetArchivedUnexpectedEventsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/unexpected-events/archived-events',
    ...options,
  })
}

/**
 * Get Unexpected Event Camera Captures
 */
export const getUnexpectedEventCameraCaptures = <ThrowOnError extends boolean = false>(
  options: Options<GetUnexpectedEventCameraCapturesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetUnexpectedEventCameraCapturesResponses,
    GetUnexpectedEventCameraCapturesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/unexpected-events/camera-captures/{event_id}',
    ...options,
  })
}

/**
 * Get Unexpected Event Details
 */
export const getUnexpectedEventDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetUnexpectedEventDetailsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetUnexpectedEventDetailsResponses,
    GetUnexpectedEventDetailsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/unexpected-events/details/{event_id}',
    ...options,
  })
}

/**
 * Get Annexations For Day
 */
export const getAnnexationsForDay = <ThrowOnError extends boolean = false>(
  options: Options<GetAnnexationsForDayData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetAnnexationsForDayResponses, GetAnnexationsForDayErrors, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/api/unexpected-events/annexations/{annexation_date}',
      ...options,
    }
  )
}

/**
 * Resolve Unexpected Event
 */
export const resolveUnexpectedEvent = <ThrowOnError extends boolean = false>(
  options: Options<ResolveUnexpectedEventData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ResolveUnexpectedEventResponses,
    ResolveUnexpectedEventErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/unexpected-events/resolve/{event_id}',
    ...options,
  })
}

/**
 * Unresolve Unexpected Event
 */
export const unresolveUnexpectedEvent = <ThrowOnError extends boolean = false>(
  options: Options<UnresolveUnexpectedEventData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    UnresolveUnexpectedEventResponses,
    UnresolveUnexpectedEventErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/unexpected-events/unresolve/{event_id}',
    ...options,
  })
}

/**
 * Get Affected Routes
 * Endpoint for returning all routes, that contains any of given route segments.
 *
 * Used in unexpected events.
 */
export const getAffectedRoutes = <ThrowOnError extends boolean = false>(
  options: Options<GetAffectedRoutesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<GetAffectedRoutesResponses, GetAffectedRoutesErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/unexpected-events/affected-routes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Env Info
 */
export const getEnvInfo = <ThrowOnError extends boolean = false>(options?: Options<GetEnvInfoData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetEnvInfoResponses, unknown, ThrowOnError>({
    url: '/api/tools/env-info',
    ...options,
  })
}

/**
 * Clean Cache
 */
export const cleanCache = <ThrowOnError extends boolean = false>(options?: Options<CleanCacheData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<CleanCacheResponses, CleanCacheErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/tools/clean-cache',
    ...options,
  })
}

/**
 * Clean Billing Cache
 */
export const cleanBillingCache = <ThrowOnError extends boolean = false>(
  options?: Options<CleanBillingCacheData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<CleanBillingCacheResponses, CleanBillingCacheErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/tools/clean-billing-cache',
    ...options,
  })
}

/**
 * Get Hotline Calls
 */
export const getHotlineCalls = <ThrowOnError extends boolean = false>(
  options: Options<GetHotlineCallsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetHotlineCallsResponses, GetHotlineCallsErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/dispatching/hotline-calls/{starting_from}/{ending_at}',
    ...options,
  })
}

/**
 * Get Chunks
 */
export const getChunks = <ThrowOnError extends boolean = false>(options?: Options<GetChunksData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetChunksResponses, GetChunksErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/vialyitcs/chunks',
    ...options,
  })
}

/**
 * Get Chunk Detail
 */
export const getChunkDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetChunkDetailData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetChunkDetailResponses, GetChunkDetailErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/vialyitcs/chunk-detail/{relative_path}',
    ...options,
  })
}

/**
 * Post Chunk Quality
 */
export const postChunkQuality = <ThrowOnError extends boolean = false>(
  options: Options<PostChunkQualityData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<PostChunkQualityResponses, PostChunkQualityErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/vialyitcs/chunk-quality',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Get Image
 */
export const getImage = <ThrowOnError extends boolean = false>(options: Options<GetImageData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<GetImageResponses, GetImageErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/vialyitcs/sample-image/{img_relative_path}',
    ...options,
  })
}

/**
 * Get Report Csv
 */
export const getReportCsv = <ThrowOnError extends boolean = false>(
  options: Options<GetReportCsvData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<GetReportCsvResponses, GetReportCsvErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/vialyitcs/report/csv/{starting_from}/{ending_at}',
    ...options,
  })
}

/**
 * List Roles
 */
export const listRoles = <ThrowOnError extends boolean = false>(options?: Options<ListRolesData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ListRolesResponses, ListRolesErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/roles',
    ...options,
  })
}

/**
 * Create Role
 */
export const createRole = <ThrowOnError extends boolean = false>(options: Options<CreateRoleData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<CreateRoleResponses, CreateRoleErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/roles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete Role
 */
export const deleteRole = <ThrowOnError extends boolean = false>(options: Options<DeleteRoleData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<DeleteRoleResponses, DeleteRoleErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/roles/{role_id}',
    ...options,
  })
}

/**
 * Get Role
 */
export const getRole = <ThrowOnError extends boolean = false>(options: Options<GetRoleData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<GetRoleResponses, GetRoleErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/roles/{role_id}',
    ...options,
  })
}

/**
 * Update Role
 */
export const updateRole = <ThrowOnError extends boolean = false>(options: Options<UpdateRoleData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<UpdateRoleResponses, UpdateRoleErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/roles/{role_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * List Users
 */
export const listUsers = <ThrowOnError extends boolean = false>(options?: Options<ListUsersData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ListUsersResponses, ListUsersErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/users',
    ...options,
  })
}

/**
 * Create User
 */
export const createUser = <ThrowOnError extends boolean = false>(options: Options<CreateUserData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<CreateUserResponses, CreateUserErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Delete User
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/users/{user_id}',
    ...options,
  })
}

/**
 * Get User
 */
export const getUser = <ThrowOnError extends boolean = false>(options: Options<GetUserData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<GetUserResponses, GetUserErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/users/{user_id}',
    ...options,
  })
}

/**
 * Update User
 */
export const updateUser = <ThrowOnError extends boolean = false>(options: Options<UpdateUserData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).put<UpdateUserResponses, UpdateUserErrors, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/users/{user_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

/**
 * Push Report
 */
export const pushReport = <ThrowOnError extends boolean = false>(options: Options<PushReportData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<PushReportResponses, PushReportErrors, ThrowOnError>({
    security: [
      {
        scheme: 'basic',
        type: 'http',
      },
    ],
    url: '/api/netmon/push-report',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}
